webpackJsonp([15],{

/***/ "/aV+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ddbeeb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gift_vue__ = __webpack_require__("eU0C");
var disposed = false
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ddbeeb5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Gift_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/icons/Gift.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4ddbeeb5", Component.options)
  } else {
    hotAPI.reload("data-v-4ddbeeb5", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "2GNu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "mt-popup",
    {
      staticClass: "takeCardsWrapper",
      attrs: { closeOnClickModal: false, "pop-transition": "popup-fade" },
      model: {
        value: _vm.visible,
        callback: function($$v) {
          _vm.visible = $$v
        },
        expression: "visible"
      }
    },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c("gift-icon"),
          _vm._v(" "),
          _c("span", { staticStyle: { "font-size": "0.35rem" } }, [
            _vm._v("今日福利")
          ]),
          _vm._v(" "),
          _c("span", [_vm._v("下单立减")])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm._l(_vm.takeCardsArr, function(activity) {
            return _vm._l(activity.cards, function(card, index) {
              return _c("take-card-item", {
                key: card.id,
                attrs: { card: card }
              })
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "footer" },
        [
          _c(
            "mt-button",
            {
              attrs: {
                type: "danger",
                size: "large",
                disabled: _vm.submitting
              },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.takeCards($event)
                }
              }
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.submitting ? "正在领取..." : "立即领取") +
                  "\n    "
              )
            ]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14792755", esExports)
  }
}

/***/ }),

/***/ "34+y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3Als":
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),

/***/ "4EG/":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),

/***/ "91KU":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.take-card {\n  display: flex;\n  align-items: stretch;\n  margin-top: 0.3rem;\n  border: 1px solid #ccc;\n  min-height: 2.1rem;\n}\n.take-card .left {\n  flex: 1;\n  text-align: center;\n  color: #f13b3a;\n  border-right: 2px #ccc dashed;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.take-card .left .amount {\n  font-size: 0.6rem;\n  font-weight: bold;\n}\n.take-card .left .num {\n  margin-top: 0.2rem;\n  font-size: 0.35rem;\n}\n.take-card .right {\n  flex: 2;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  padding: 0.15rem 0.2rem;\n}\n", ""]);

// exports


/***/ }),

/***/ "9qvX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export wxConfig */
/* harmony export (immutable) */ __webpack_exports__["b"] = wxDisableShareMenu;
/* harmony export (immutable) */ __webpack_exports__["c"] = wxScan;
/* unused harmony export wxUpdateAppMessageShareData */
/* harmony export (immutable) */ __webpack_exports__["a"] = wxCloseWindow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_api_interface_gateway__ = __webpack_require__("wMDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_config_store_config__ = __webpack_require__("G4VM");







var wxHideMenuPromise = null;
var wxHideMenuRouteKey = '';

/**
 * 1. 通过config接口注入权限验证配置
 * 所有需要使用JS-SDK的页面必须先注入配置信息，否则将无法调用
 *
 * 2. config信息验证后会执行ready方法，
 * 所有接口调用都必须在config接口获得结果之后，
 * config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。
 * 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
 *
 * 3.config信息验证失败会执行error函数，
 * 如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
 */
function wxConfig() {
  var clientUrl = window.location.href.split('#')[0],
      stamp = new Date().getTime() / 1000 | 0,
      nonce = Object(__WEBPACK_IMPORTED_MODULE_4_src_components_api_utils__["q" /* randomString */])(16);
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    if (__WEBPACK_IMPORTED_MODULE_5_src_config_store_config__["a" /* default */].state.wxJsApiConfigStatus === true) {
      resolve('success');
      return;
    }
    Object(__WEBPACK_IMPORTED_MODULE_3_src_components_api_interface_gateway__["a" /* weChatJsSdkSign */])({
      clientUrl: clientUrl,
      stamp: stamp,
      nonce: nonce
    }).then(function (res) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: Object(__WEBPACK_IMPORTED_MODULE_2_src_components_api_interface_hhy__["p" /* getUserIdentity */])('appId'), // 必填，公众号的唯一标识
        timestamp: stamp, // 必填，生成签名的时间戳
        nonceStr: nonce, // 必填，生成签名的随机串
        signature: res, // 必填，签名
        jsApiList: ['scanQRCode', 'updateAppMessageShareData', 'closeWindow', 'hideOptionMenu'] // 必填，需要使用的JS接口列表
      });
      wx.ready(function () {
        __WEBPACK_IMPORTED_MODULE_5_src_config_store_config__["a" /* default */].commit('setWxJsApiConfigStatus', true);
        resolve('success');
      });
      wx.error(function (res) {
        console.error('微信config验证失败', res);
        __WEBPACK_IMPORTED_MODULE_5_src_config_store_config__["a" /* default */].commit('setWxJsApiConfigStatus', false);
        reject(res);
      });
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_5_src_config_store_config__["a" /* default */].commit('setWxJsApiConfigStatus', false);
      reject(error);
    });
  });
}

/**
 * 禁用微信右上角菜单（全页面禁用分享）
 * @return {Promise}
 */
function wxDisableShareMenu() {
  var routeKey = window.location.href;
  if (wxHideMenuRouteKey === routeKey) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve('success');
  }
  if (wxHideMenuPromise) {
    return wxHideMenuPromise;
  }
  wxHideMenuPromise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    wxConfig().then(function () {
      if (typeof wx === 'undefined' || typeof wx.hideOptionMenu !== 'function') {
        wxHideMenuPromise = null;
        resolve('unsupported');
        return;
      }
      wx.hideOptionMenu({
        success: function success() {
          wxHideMenuRouteKey = routeKey;
          resolve('success');
        },
        fail: function fail(err) {
          console.error('微信禁用右上角菜单失败', err);
          resolve('fail');
        },
        complete: function complete() {
          wxHideMenuPromise = null;
        }
      });
    }).catch(function (err) {
      console.error('微信禁用分享菜单失败', err);
      wxHideMenuPromise = null;
      resolve('fail');
    });
  });
  return wxHideMenuPromise;
}
/**
 * 微信扫一扫
 * @return {Promise}
 */
function wxScan() {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    wxConfig().then(function (res) {
      wx.scanQRCode({
        needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
        scanType: ['qrCode'], // 可以指定扫二维码还是一维码，默认二者都有
        success: function success(res) {
          var result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
          resolve(result);
        },
        error: function error(res) {
          reject(res);
        }
      });
    }).catch(function (err) {
      reject(err);
    });
  });
}

/**
 * 分享：自定义“分享给朋友”及“分享到QQ”按钮的分享内容
 * @return {Promise}
 */
function wxUpdateAppMessageShareData(params) {
  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    wxConfig().then(function (res) {
      wx.updateAppMessageShareData(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, params, {
        success: function success() {
          resolve('success');
        },
        fail: function fail(err) {
          reject(err);
        }
      }));
    }).catch(function (err) {
      reject(err);
    });
  });
}

/**
 * 关闭当前网页窗口
 */
function wxCloseWindow() {
  wxConfig().then(function (res) {
    wx.closeWindow();
  }).catch(function (err) {
    console.error(err);
  });
}

/***/ }),

/***/ "CWZo":
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),

/***/ "CcCL":
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__("kxFB");
exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\nhtml,\nbody {\n  line-height: 1;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', sans-serif;\n  user-select: none;\n  -webkit-tap-highlight-color: transparent;\n  background: #f5f6f8;\n  color: #333;\n  min-height: 100%;\n  width: 100%;\n  -webkit-font-smoothing: antialiased;\n  text-rendering: optimizeLegibility;\n}\nbody {\n  font-size: 14px;\n}\n#app {\n  min-height: 100%;\n}\na {\n  color: inherit;\n  text-decoration: none;\n}\nbutton,\ninput,\ntextarea {\n  font-family: inherit;\n}\n.clearfix {\n  display: inline-block;\n}\n.clearfix:after {\n  display: block;\n  content: '';\n  height: 0;\n  line-height: 0;\n  clear: both;\n  visibility: hidden;\n}\n@font-face {\n  font-family: 'sell-icon';\n  src: url(" + escape(__webpack_require__("3Als")) + ");\n  src: url(" + escape(__webpack_require__("3Als")) + "#iefix) format('embedded-opentype'), url(" + escape(__webpack_require__("yeJ9")) + ") format('truetype'), url(" + escape(__webpack_require__("CWZo")) + ") format('woff'), url(" + escape(__webpack_require__("Pgnm")) + "#sell-icon) format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^=\"icon-\"],\n[class*=\" icon-\"] {\n/* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'sell-icon' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n/* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-arrow_lift:before {\n  content: \"\\E900\";\n}\n.icon-check_circle:before {\n  content: \"\\E901\";\n}\n.icon-close:before {\n  content: \"\\E902\";\n}\n.icon-favorite:before {\n  content: \"\\E903\";\n}\n.icon-keyboard_arrow_right:before {\n  content: \"\\E904\";\n}\n.icon-remove_circle_outline:before {\n  content: \"\\E905\";\n}\n.icon-shopping_cart:before {\n  content: \"\\E906\";\n}\n.icon-thumb_down:before {\n  content: \"\\E907\";\n}\n.icon-thumb_up:before {\n  content: \"\\E908\";\n}\n.icon-add_circle:before {\n  content: \"\\1F4\";\n}\n@font-face {\n  font-family: \"iconfont\";\n  src: url(" + escape(__webpack_require__("4EG/")) + ") format('truetype'), url(" + escape(__webpack_require__("Fe2/")) + "#iconfont) format('svg'); /* iOS 4.1- */\n}\n.iconfont {\n  font-family: \"iconfont\" !important;\n  font-size: 0.8rem;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.icon-jinggao:before {\n  content: \"\\E6B6\";\n}\n.icon-bixuan:before {\n  content: \"\\E69A\";\n}\n.icon-bianji:before {\n  content: \"\\E615\";\n}\n.icon-jiantoushang:before {\n  content: \"\\E62C\";\n}\n.icon-jiantoushang1:before {\n  content: \"\\E62D\";\n}\n.icon-ziyuan:before {\n  content: \"\\E647\";\n}\n.icon-left-circle-o:before {\n  content: \"\\E77F\";\n}\n.icon-tag:before {\n  content: \"\\E7E4\";\n}\n.icon-shanguangdengzidong:before {\n  content: \"\\EAE0\";\n}\n.icon-shouji:before {\n  content: \"\\E625\";\n}\n.footer-btn-wrapper {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding: 0.18rem 0.3rem 0.28rem;\n  width: 100%;\n  z-index: 20;\n  display: -webkit-flex;\n  display: flex;\n  gap: 0.2rem;\n  text-align: center;\n  box-sizing: border-box;\n  background: linear-gradient(to top, rgba(245,246,248,0.98), rgba(245,246,248,0.88), rgba(245,246,248,0));\n}\n.footer-btn-wrapper button {\n  height: 1.33333rem;\n  border-radius: 999px;\n  border: none;\n}\n.footer-btn-wrapper a,\n.footer-btn-wrapper button {\n  display: -webkit-flex;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 1.33333rem;\n  padding: 0 0.36rem;\n  border-radius: 999px;\n  font-size: 0.4rem;\n  font-weight: 600;\n  letter-spacing: 0.01rem;\n  color: #fff;\n  text-align: center;\n}\n.footer-btn-wrapper .dinner-btn-submit,\n.footer-btn-wrapper .dinner-submit-btn {\n  font-size: 0.4rem;\n  color: #fff;\n  background: linear-gradient(135deg, #f58e18, #e37d08);\n  flex: 1 1 3rem;\n  box-shadow: 0 0.12rem 0.28rem rgba(245,142,24,0.24);\n}\n.footer-btn-wrapper .dinner-btn-default,\n.footer-btn-wrapper .dinner-default-btn {\n  font-size: 0.4rem;\n  color: #fff;\n  background: #353535;\n  flex: 10 10;\n  box-shadow: 0 0.1rem 0.26rem rgba(53,53,53,0.2);\n}\n.footer-btn-wrapper .dinner-btn-submit.is-disabled,\n.footer-btn-wrapper .dinner-btn-default.is-disabled,\n.footer-btn-wrapper .dinner-submit-btn.is-disabled,\n.footer-btn-wrapper .dinner-default-btn.is-disabled,\n.footer-btn-wrapper button[disabled] {\n  opacity: 0.5;\n  box-shadow: none;\n}\n.page-card {\n  background: #fff;\n  border-radius: 0.28rem;\n  box-shadow: 0 0.1rem 0.3rem rgba(31,35,41,0.08);\n}\n.section-title {\n  color: #333;\n  font-size: 0.4rem;\n  font-weight: 600;\n}\n.section-desc {\n  color: #8c8c8c;\n  font-size: 0.33rem;\n  line-height: 1.5;\n}\n.textRed {\n  color: #fb4e44 !important;\n}\n.textGray {\n  color: #8c8c8c !important;\n}\n.left-circle-o-white {\n  background-color: #999;\n  color: #fff;\n  border-radius: 50%;\n}\n.containerBox {\n  min-height: 100%;\n  width: 100%;\n  background: #f5f6f8;\n}\n.mint-toast {\n  z-index: 2050;\n}\n", ""]);

// exports


/***/ }),

/***/ "Fe2/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iconfont.539ab22.svg";

/***/ }),

/***/ "G4VM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_message_box_style_css__ = __webpack_require__("OgVB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_message_box_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mint_ui_lib_message_box_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_message_box__ = __webpack_require__("/Lyv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_message_box___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_message_box__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__ = __webpack_require__("RRo+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__("gRE1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store_const_js__ = __webpack_require__("pT0i");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store_utils_js__ = __webpack_require__("KHum");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vuex_persistedstate__ = __webpack_require__("424j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__ = __webpack_require__("qkUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_src_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__ = __webpack_require__("M/o6");











 // state数据持久化





__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_7_vuex__["a" /* default */].Store({
  state: {
    foodsInCart: [],
    orderNote: '',
    arriveTime: 0, // 配送详情-送达时间
    personNum: 0, // 配送详情-人数
    cartBranchId: 0, // 当前购物车数据对应的门店id，进入菜例列表时设置
    popStateListener: [], // 用于监听全屏子组件popState, 判断当前路由是直接返回还是隐藏子组件 {stateName: , callBackFunction:}
    requiredFoods: [], // 必选菜品
    requiredGroupFoods: [], // 必选菜品
    paidOrderIdWithin2Hours: '', // 2小时内用户成功支付的订单编号，如果有则必选菜不强制添加
    suitSelectedFoods: {}, // 可选套餐点选的菜品（加入购物车前）
    currentSuitDiffPriceMapByGroupId: {}, // 当前套餐加价信息：{groupId1: 2, groupId2: 5}
    oneColDisplay: null, // 商品列表显示单列模式
    clickEventOn: false, // 是否正在发生点击事件，用于防止重复点击事件（如嵌套的BScroll）
    businessSetting: {},
    preOrderDetail: {},
    mqConnectStatus: __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["d" /* CONNECT_STATUS_WAITTING */], // mq链接状态
    mqMessagePayLoad: null, // mq消息内容
    mqRequestId: '', // mq requestId
    selectedCard: {}, // 选中的卡券
    pointsChecked: [], // 使用积分复选框
    wxJsApiConfigStatus: null, // 微信JS-SDK是否已注入权限验证配置 true成功 false失败
    forAnotherPay: false, // 是否是为朋友代付（微信分享打开）
    takeCardsModalVisible: false, // 领取卡券modal显示状态
    takeCardsArr: [], // 要领取的卡券
    takeCardsSearch: false,
    takeCardsBranchIds: [], // 处理过领券下单业务的门店，用于外卖/秒吃/自提多门店应用切换门店
    welcomeImgVisible: false // 应用启动欢迎图片显示状态
  },
  // state 数据持久化防止刷新失效
  plugins: [Object(__WEBPACK_IMPORTED_MODULE_10_vuex_persistedstate__["a" /* default */])({
    paths: ['foodsInCart', 'orderNote', 'arriveTime', 'personNum', 'cartBranchId', 'requiredFoods', 'paidOrderIdWithin2Hours', 'businessSetting', 'mqConnectStatus', 'mqMessagePayLoad', 'mqRequestId', 'selectedCard', 'takeCardsModalVisible', 'takeCardsArr', 'takeCardsSearch', 'takeCardsBranchIds', 'welcomeImgVisible'],
    storage: window.sessionStorage
  })],
  getters: {
    // 计算购物车中菜品总数量和总金额
    cartFoodsTotal: function cartFoodsTotal(state, getters) {
      var foods = state.foodsInCart.length > 0 ? state.foodsInCart : state.preOrderDetail.foodList || [],
          count = 0,
          amount = 0;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foods), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var food = _step.value;

          count += food.count || food.qty;
          var price = getters.getCartFoodTotalPrice(food);
          amount += price;
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return { count: count, amount: amount };
    },
    cartFoodsTotalPriceOriginal: function cartFoodsTotalPriceOriginal(state, getters) {
      var foods = state.foodsInCart.length > 0 ? state.foodsInCart : state.preOrderDetail.foodList || [],
          amount = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foods), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var food = _step2.value;

          var price = getters.getCartFoodTotalPriceOriginal(food);
          amount += price;
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return amount;
    },
    // 第二份半价优惠活动
    cartFoodsHalfTotal: function cartFoodsHalfTotal(state, getters) {
      var foods = state.foodsInCart.length > 0 ? state.foodsInCart : state.preOrderDetail.foodList || [],
          halfAmount = 0;
      var halfFoods = foods.filter(function (food) {
        return food.halfPrice !== -1;
      });
      var noHalfFoods = foods.filter(function (food) {
        return food.halfPrice === -1;
      });
      if (halfFoods.length > 0) {
        if (halfFoods[0].halfDistype === 'LOW') {
          halfFoods.sort(function (a, b) {
            return a.price - b.price;
          });
        } else {
          halfFoods.sort(function (a, b) {
            return b.price - a.price;
          });
        }
        console.log(halfFoods);
        var sumQty = 0;
        halfFoods.forEach(function (item) {
          sumQty += item.count || item.qty;
        });
        var halfBaseQty = halfFoods[0].halfBaseQty;
        var halfDisQty = halfFoods[0].halfDisQty;
        var needHalfDisQty = 0;
        if (halfBaseQty > 0) {
          needHalfDisQty = Math.floor(sumQty / halfBaseQty * halfDisQty);
        }
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(halfFoods), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var food = _step3.value;

            if (needHalfDisQty > 0) {
              var qty = food.count || food.qty;
              if (needHalfDisQty >= qty) {
                halfAmount += food.halfPrice * qty;
                needHalfDisQty -= qty;
              } else {
                halfAmount += food.halfPrice * needHalfDisQty + food.price * (qty - needHalfDisQty);
                needHalfDisQty = 0;
              }
            } else {
              var price = getters.getCartFoodTotalPriceOriginal(food);
              halfAmount += price;
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }
      if (noHalfFoods.length > 0) {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(noHalfFoods), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var _food = _step4.value;

            var _price = getters.getCartFoodTotalPriceOriginal(_food);
            halfAmount += _price;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }
      }
      return halfAmount;
    },
    // 验证必选菜是否在购物车中
    checkRequiredFoodsInCart: function checkRequiredFoodsInCart(state) {
      if (state.paidOrderIdWithin2Hours !== '' || Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType') !== __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */]) {
        return { validate: true };
      }
      var branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
          orderFoods = state.foodsInCart.concat(branchDish);
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.requiredFoods), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var food = _step5.value;

          var foodCountLimit = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? state.personNum : 1,
              orderFoodCount = 0;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(orderFoods), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var orderFood = _step7.value;

              if (orderFood.id && orderFood.id === food.id) {
                // 购物车点菜
                orderFoodCount += orderFood.count;
              } else if (orderFood.goodsName === food.name) {
                // 门店点菜
                orderFoodCount += orderFood.num;
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }

          if (orderFoodCount < foodCountLimit) {
            var msg = foodCountLimit > 1 ? '请按人数点餐' : '请至少点一份';
            return { validate: false, message: '点菜信息错误：必选菜品（' + food.name + '）' + msg };
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      var groupFoodRequiredName = '';
      var groupFoodRequiredUnChecked = state.requiredGroupFoods.length > 0;
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.requiredGroupFoods), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var groupFood = _step6.value;

          groupFoodRequiredName = groupFood.name;
          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(orderFoods), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _orderFood = _step8.value;

              if (_orderFood.id && _orderFood.id === groupFood.id) {
                // 购物车点菜
                groupFoodRequiredUnChecked = false;
                break;
              } else if (_orderFood.goodsName === groupFood.name) {
                // 门店点菜
                groupFoodRequiredUnChecked = false;
                break;
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }

      if (groupFoodRequiredUnChecked) {
        return { validate: false, message: '【' + groupFoodRequiredName + '】是必选的哦' };
      }
      return { validate: true };
    },
    /**
     * 按索引查询购物车中的某个菜
     * @param state
     */
    getCartFoodByIndex: function getCartFoodByIndex(state) {
      return function (index) {
        return state['foodsInCart'][index];
      };
    },
    ifHaveSpecOrSettings: function ifHaveSpecOrSettings(state) {
      return function (food) {
        var settingList = food.settingInfoList;
        if (settingList && settingList.length > 0) {
          return true;
        }
        var specList = food.specInfoList;
        if (specList && specList.length > 1) {
          return true;
        }
        return false;
      };
    },
    /**
     * 计算某菜品是否有必选要求
     * @param state
     */
    ifHaveMustSetting: function ifHaveMustSetting(state) {
      return function (food) {
        var settingList = food.settingInfoList;
        if (!settingList || settingList.length === 0) {
          return false;
        }
        var index = settingList.findIndex(function (setting) {
          if (setting.canMust !== state.appConst.FOOD_SETTING_MUST_YES) {
            return false;
          }
          if (!setting.settingOptList || setting.settingOptList.length === 0) {
            return false;
          }
          return true;
        });

        if (index === -1) {
          return false;
        }
        return true;
      };
    },
    /**
     * 计算某个菜品（id一致）在购物车中的数量
     * 例如，同一个套餐（不同点选或要求）在购物车中的数量、同一个菜（不同的要求）在购物车中的数量
     * @param state
     */
    foodCountInCart: function foodCountInCart(state) {
      return function (foodId) {
        var foodsInCart = state.foodsInCart;
        if (foodsInCart.length === 0) {
          return 0;
        }
        var count = 0;
        foodId = foodId - 0;
        var _iteratorNormalCompletion9 = true;
        var _didIteratorError9 = false;
        var _iteratorError9 = undefined;

        try {
          for (var _iterator9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foodsInCart), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
            var food = _step9.value;

            if (food.id - 0 === foodId) {
              count += food.count;
            }
          }
        } catch (err) {
          _didIteratorError9 = true;
          _iteratorError9 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion9 && _iterator9.return) {
              _iterator9.return();
            }
          } finally {
            if (_didIteratorError9) {
              throw _iteratorError9;
            }
          }
        }

        return count;
      };
    },
    /**
     * 当前正在点选的套餐的总差价
     * @param state
     * @return {number}
     */
    currentSuitDiffPrice: function currentSuitDiffPrice(state) {
      var diffPrices = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(state.currentSuitDiffPriceMapByGroupId),
          totalDiffPrice = 0;
      if (diffPrices.length === 0) {
        return 0;
      }
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(diffPrices), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var diffPrice = _step10.value;

          totalDiffPrice += diffPrice - 0;
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }

      return totalDiffPrice;
    },
    /**
     * 计算购物车中某个套餐菜的差价
     * @param state
     */
    cartSuitDiffPrice: function cartSuitDiffPrice(state) {
      return function (suit) {
        var groups = suit.foodSuitGroups || suit.suitGroups || [],
            totalDiffPrice = 0;
        var _iteratorNormalCompletion11 = true;
        var _didIteratorError11 = false;
        var _iteratorError11 = undefined;

        try {
          for (var _iterator11 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(groups), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
            var group = _step11.value;

            var cartDetails = group.cartDetails || group.details;
            var _iteratorNormalCompletion12 = true;
            var _didIteratorError12 = false;
            var _iteratorError12 = undefined;

            try {
              for (var _iterator12 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(cartDetails), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
                var detail = _step12.value;

                totalDiffPrice += (detail.diffprice || detail.diffPrice || 0) * (detail.userCount || 1) - 0;
              }
            } catch (err) {
              _didIteratorError12 = true;
              _iteratorError12 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion12 && _iterator12.return) {
                  _iterator12.return();
                }
              } finally {
                if (_didIteratorError12) {
                  throw _iteratorError12;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError11 = true;
          _iteratorError11 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion11 && _iterator11.return) {
              _iterator11.return();
            }
          } finally {
            if (_didIteratorError11) {
              throw _iteratorError11;
            }
          }
        }

        return totalDiffPrice;
      };
    },
    /**
     * 某个菜例在购物车中的总价格     会员价
     * @param state
     * @param getters
     */
    getCartFoodTotalPrice: function getCartFoodTotalPrice(state, getters) {
      return function (food) {
        var price = food.costPrice === -1 ? food.price : food.costPrice;
        if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL) {
          var diffPrice = getters.cartSuitDiffPrice(food);
          price += diffPrice - 0;
        }
        return price * (food.count || food.qty);
      };
    },
    /**
     * 某个菜例在购物车中的总的原始价格（用于设置了不显示会员价的商户的页面显示）
     * @param state
     * @param getters
     */
    getCartFoodTotalPriceOriginal: function getCartFoodTotalPriceOriginal(state, getters) {
      return function (food) {
        var price = food.price;
        if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL) {
          var diffPrice = getters.cartSuitDiffPrice(food);
          price += diffPrice - 0;
        }
        return price * (food.count || food.qty);
      };
    },
    /**
     * 用于显示的订单整单备注
     * @param state
     * @return {*}
     */
    orderNoteShown: function orderNoteShown(state) {
      var note = state.orderNote;
      if (note && note.indexOf('打包带走')) {
        return note.replace('打包带走', '');
      }
      return note;
    }
  },
  mutations: {
    setOrderNote: function setOrderNote(state, allNote) {
      state.orderNote = allNote;
    },
    // 将商品加入购物车
    addFoodsToCart: function addFoodsToCart(state, food) {
      // 加入购物车
      if (food.foodType === state.appConst.FOOD_TYPE_SET_MEAL && (!food.foodSuitGroups || food.foodSuitGroups.length === 0)) {
        return false;
      }
      var temp = state.foodsInCart.findIndex(function (item) {
        // 查找匹配的商品
        if (item.id !== food.id || item.specId !== food.specId || item.optionList !== food.optionList || food.foodType !== item.foodType) {
          return false;
        }
        if (food.foodType !== state.appConst.FOOD_TYPE_SET_MEAL) {
          return true;
        }
        if (food.foodSuitGroups.length !== item.foodSuitGroups.length) {
          return false;
        }
        // 以id-specId为键的所有详情菜
        var foodDetailsMapById = state.appUtils.getSuitCartDetailsMapById(food);
        var itemDetailsMapById = state.appUtils.getSuitCartDetailsMapById(item);
        var foodDetailsIdArr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(foodDetailsMapById),
            itemDetailsIdArr = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(itemDetailsMapById);
        if (foodDetailsIdArr.length !== itemDetailsIdArr.length) {
          return false;
        }
        var _iteratorNormalCompletion13 = true;
        var _didIteratorError13 = false;
        var _iteratorError13 = undefined;

        try {
          for (var _iterator13 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foodDetailsIdArr), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
            var detailId = _step13.value;

            var foodDetail = foodDetailsMapById[detailId],
                itemDetail = itemDetailsMapById[detailId];
            if (!itemDetail) {
              return false;
            }
            if (itemDetail.optionList !== foodDetail.optionList || itemDetail.userCount !== foodDetail.userCount) {
              return false;
            }
          }
        } catch (err) {
          _didIteratorError13 = true;
          _iteratorError13 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion13 && _iterator13.return) {
              _iterator13.return();
            }
          } finally {
            if (_didIteratorError13) {
              throw _iteratorError13;
            }
          }
        }

        return true;
      });
      if (temp === -1) {
        var initCount = 1;
        if (food.addCount) {
          initCount = food.addCount;
        } else if (food.multiple === state.appConst.FOOD_MULTIPLE_YES && food.mincount > 0) {
          initCount = food.mincount;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType') === __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && state.paidOrderIdWithin2Hours === '' && food.required === state.appConst.FOOD_REQUIRED_YES && food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE) {
          var branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
              branchFoodCount = 0; // 门店点菜
          var _iteratorNormalCompletion14 = true;
          var _didIteratorError14 = false;
          var _iteratorError14 = undefined;

          try {
            for (var _iterator14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(branchDish), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
              var branchFood = _step14.value;

              if (branchFood.goodsName === food.name) {
                branchFoodCount += branchFood.num - 0;
              }
            }
          } catch (err) {
            _didIteratorError14 = true;
            _iteratorError14 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion14 && _iterator14.return) {
                _iterator14.return();
              }
            } finally {
              if (_didIteratorError14) {
                throw _iteratorError14;
              }
            }
          }

          initCount = branchFoodCount < state.personNum ? state.personNum - branchFoodCount : 1;
        }
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(initCount) === false) {
          initCount = initCount.toFixed(2) - 0;
        }
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(food, 'count', initCount); // 该食品是否有count属性，没有就添加并初始化为1;
        if (!food.optionList) {
          __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(food, 'optionList', '');
        }
        state.foodsInCart.push(food);
      } else {
        var cartFood = state.foodsInCart[temp];
        if (cartFood.count >= food.qty) {
          // 估清
          return false;
        }
        var addCount = food.addCount ? food.addCount : 1,
            targetCount = cartFood.count + addCount;

        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(targetCount) === false) {
          targetCount = targetCount.toFixed(2) - 0;
        }
        cartFood.count = targetCount;
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(state.foodsInCart, temp, cartFood);
      }
      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.delete(food, 'addCount');
      Object(__WEBPACK_IMPORTED_MODULE_13_src_components_api_utils__["s" /* setLocalStorageItem */])('cartInfo' + state.cartBranchId, {
        foodsInCart: state.foodsInCart,
        personNum: state.personNum,
        businessType: Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType')
      }, 1 * 60 * 60 * 1000);
    },
    // 从购物车中移除商品
    removeFoodsFromCart: function removeFoodsFromCart(state, food) {
      var temp = state.foodsInCart.findIndex(function (item) {
        // 查找匹配的商品
        return item.name === food.name && item.id === food.id && item.specId === food.specId && item.optionList === food.optionList;
      });

      if (temp !== -1) {
        var currentFood = state.foodsInCart[temp],
            reduceCount = food.reduceCount ? food.reduceCount : 1,
            // 要移除的数量
        targetCount = Math.max(currentFood.count - reduceCount, 0);
        if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_is_integer___default()(targetCount) === false) {
          targetCount = targetCount.toFixed(2) - 0;
        }
        if (currentFood.count > 0) {
          // 默认选多份的商品，起售数量移除时，数量变为0
          if (food.multiple === state.appConst.FOOD_MULTIPLE_YES && targetCount < food.mincount) {
            currentFood.count = 0;
          } else if (Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType') === __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && state.paidOrderIdWithin2Hours === '' && food.required === state.appConst.FOOD_REQUIRED_YES) {
            // 必选菜品
            var branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
                branchFoodCount = 0; // 门店点菜
            var _iteratorNormalCompletion15 = true;
            var _didIteratorError15 = false;
            var _iteratorError15 = undefined;

            try {
              for (var _iterator15 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(branchDish), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
                var branchFood = _step15.value;

                if (branchFood.goodsName === food.name) {
                  branchFoodCount += branchFood.num - 0;
                }
              }
            } catch (err) {
              _didIteratorError15 = true;
              _iteratorError15 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion15 && _iterator15.return) {
                  _iterator15.return();
                }
              } finally {
                if (_didIteratorError15) {
                  throw _iteratorError15;
                }
              }
            }

            var minCount = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? state.personNum : 1;
            minCount = Math.max(minCount - branchFoodCount, 0);
            if (targetCount >= minCount) {
              currentFood.count = targetCount;
            }
          } else {
            currentFood.count = targetCount;
          }
          if (currentFood.count === 0) {
            state.foodsInCart.splice(temp, 1);
          } else {
            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(state.foodsInCart, temp, currentFood);
          }
        } else {
          state.foodsInCart.splice(temp, 1);
        }
        __WEBPACK_IMPORTED_MODULE_6_vue___default.a.delete(food, 'reduceCount');
        Object(__WEBPACK_IMPORTED_MODULE_13_src_components_api_utils__["s" /* setLocalStorageItem */])('cartInfo' + state.cartBranchId, {
          foodsInCart: state.foodsInCart,
          personNum: state.personNum,
          businessType: Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType')
        }, 1 * 60 * 60 * 1000);
      }
    },
    // 静默清空购物车，不询问
    setCartEmptySilent: function setCartEmptySilent(state) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var requiredFoods = [],
          foodsInCart = state.foodsInCart;
      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foodsInCart), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var food = _step16.value;

          if (force === false && Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType') === __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && state.paidOrderIdWithin2Hours === '' && food.required === state.appConst.FOOD_REQUIRED_YES) {
            requiredFoods.push(food);
          } else {
            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(food, 'count', 0);
          }
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }

      state.foodsInCart = requiredFoods;
      window.localStorage.removeItem('cartInfo' + state.cartBranchId);
    },
    // 设置到店时间
    setArriveTime: function setArriveTime(state, arriveTime) {
      state.arriveTime = arriveTime;
    },
    // 设置到店人数
    setPersonNum: function setPersonNum(state, personNum) {
      state.personNum = personNum;
    },
    // 设置购物车门店id
    setCartBranchId: function setCartBranchId(state, branchId) {
      state.cartBranchId = branchId;
    },
    /**
     * 设置popstate监听信息, 用于弹出全屏子组件时
     * @param {Object} listenerInfo {stateName: 'food-detail', callBackFunction: function () {}}
    */
    addPopStateListener: function addPopStateListener(state, listenerInfo) {
      var stateName = listenerInfo.stateName;
      window.history.pushState({ name: stateName }, '', '');
      state.popStateListener.push(listenerInfo);
    },

    // 移除popstate监听信息, 用于隐藏全屏子组件时
    deletePopStateListener: function deletePopStateListener(state) {
      var popListener = state.popStateListener.pop();
      popListener['callBackFunction']();
      // history.go(-1);
    },

    // 接受门店消息后存储消息内容
    // setBranchMessagePayLoad (state, payLoad) {
    //   state.branchMessagePayLoad = payLoad;
    // },
    // mq接受消息后存储mq消息内容
    setMqMessagePayLoad: function setMqMessagePayLoad(state, payLoad) {
      state.mqMessagePayLoad = payLoad;
    },

    // 设置mq链接状态，初始状态为'waitting'等待链接
    setMqConnectStatus: function setMqConnectStatus(state, status) {
      state.mqConnectStatus = status;
    },

    // 设置mq requestId
    setMqRequestId: function setMqRequestId(state, requestId) {
      state.mqRequestId = requestId;
    },

    // 设置必选菜品
    setRequiredFoods: function setRequiredFoods(state, requiredFoods) {
      state.requiredFoods = requiredFoods;
    },

    // 设置必选菜品
    setRequiredGroupFoods: function setRequiredGroupFoods(state, requiredGroupFoods) {
      state.requiredGroupFoods = requiredGroupFoods;
    },
    setPaidOrderIdWithin2Hours: function setPaidOrderIdWithin2Hours(state, orderId) {
      state.paidOrderIdWithin2Hours = orderId;
    },

    /**
     * 初始化可选套餐已选菜品信息
     * @param {Object} suitInfo 套餐菜基本信息
     */
    suitSelectedFoodsInit: function suitSelectedFoodsInit(state, suitInfo) {
      suitInfo.foodSuitGroups = {};
      state.suitSelectedFoods = suitInfo;
    },

    /**
     * 可选套餐设置分组点选信息
     * @param state
     * @param group
     */
    suitSelectedFoodsSetGroup: function suitSelectedFoodsSetGroup(state, group) {
      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(state.suitSelectedFoods.foodSuitGroups, group.id, group);
    },

    /**
     * 设置某套餐的某分组的加价信息
     * @param state
     * @param groupDiffPrice 分组加价信息：{groupId: 1, diifPrice: 5}
     */
    currentSuitDiffPriceSetGroup: function currentSuitDiffPriceSetGroup(state, groupDiffPrice) {
      __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(state.currentSuitDiffPriceMapByGroupId, groupDiffPrice.groupId, groupDiffPrice.diffPrice);
    },

    /**
     * 重置当前套餐的差价信息，用于套餐开始点选之前的初始化
     * @param state
     */
    currentSuitDiffPriceReset: function currentSuitDiffPriceReset(state) {
      state.currentSuitDiffPriceMapByGroupId = {};
    },

    /**
     * 设置商品列表展示模式
     * @param state
     * @param oneColDisplay
     */
    oneColDisplaySet: function oneColDisplaySet(state, oneColDisplay) {
      state.oneColDisplay = oneColDisplay;
    },

    /**
     * 开始点击事件
     * @param state
     */
    clickEventOnStart: function clickEventOnStart(state) {
      state.clickEventOn = true;
      setTimeout(function () {
        state.clickEventOn = false;
      }, 200);
    },
    setBusinessSetting: function setBusinessSetting(state, setting) {
      state.businessSetting = setting;
    },

    /**
     * 管理预订单详情，用于加菜
     * @param state
     * @param order
     */
    setPreOrderDetail: function setPreOrderDetail(state, order) {
      state.preOrderDetail = order;
    },

    /**
     * 选择卡券
     * @param state
     * @param {Object} card 卡券
     */
    selectCard: function selectCard(state, card) {
      state.selectedCard = card;
    },

    /**
     * 选择使用积分
     * @param state
     * @param {Array} checkedArr
     */
    pointsCheck: function pointsCheck(state, checkedArr) {
      state.pointsChecked = checkedArr;
    },

    /**
     * 微信JS-SDK权限验证配置状态
     * @param state
     * @param status
     */
    setWxJsApiConfigStatus: function setWxJsApiConfigStatus(state, status) {
      state.wxJsApiConfigStatus = status;
    },

    /**
     * 是否是为朋友代付
     * @param state
     * @param isForAnotherPay
     */
    setForAnotherPay: function setForAnotherPay(state, isForAnotherPay) {
      state.forAnotherPay = isForAnotherPay;
    },

    /**
     * 切换领券modal的可见状态
     * @param state
     */
    setTakeCardsModalVisible: function setTakeCardsModalVisible(state, visible) {
      state.takeCardsModalVisible = visible;
    },

    /**
     * 领券活动的卡券
     * @param state
     * @param cards
     */
    setTakeCardsArr: function setTakeCardsArr(state, cards) {
      state.takeCardsArr = cards;
    },

    /**
     * 添加处理过领券下单的门店
     * @param state
     * @param branchId
     */
    addTakeCardsBranchIds: function addTakeCardsBranchIds(state, branchId) {
      state.takeCardsBranchIds.push(branchId);
    },
    setTakeCardsSearch: function setTakeCardsSearch(state, search) {
      state.takeCardsSearch = search;
    },

    /**
     * 变更欢迎页的显示状态
     * @param state
     * @param visible
     */
    setWelcomeImgVisible: function setWelcomeImgVisible(state, visible) {
      state.welcomeImgVisible = visible;
    }
  },
  actions: {
    // 多个菜品批量加入购物车（再来一单）
    addOrderFoodsToCart: function addOrderFoodsToCart(_ref, foods) {
      var commit = _ref.commit;

      if (foods.length > 0) {
        var _iteratorNormalCompletion17 = true;
        var _didIteratorError17 = false;
        var _iteratorError17 = undefined;

        try {
          for (var _iterator17 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(foods), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
            var orderFood = _step17.value;

            commit('addFoodsToCart', orderFood);
          }
        } catch (err) {
          _didIteratorError17 = true;
          _iteratorError17 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion17 && _iterator17.return) {
              _iterator17.return();
            }
          } finally {
            if (_didIteratorError17) {
              throw _iteratorError17;
            }
          }
        }
      }
    },

    // 更改购物车门店
    changeCartBranchId: function changeCartBranchId(_ref2, branchId) {
      var commit = _ref2.commit,
          state = _ref2.state,
          dispatch = _ref2.dispatch;

      if (state.cartBranchId !== branchId) {
        var localStorageCartInfo = Object(__WEBPACK_IMPORTED_MODULE_13_src_components_api_utils__["l" /* getLocalStorageItem */])('cartInfo' + branchId);
        commit('setCartBranchId', branchId);
        commit('setCartEmptySilent', true);
        // 检查localStorage中是否有购物车数据，若匹配的购物车数据则交由vuex管理
        if (localStorageCartInfo && localStorageCartInfo.businessType === Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType')) {
          commit('setPersonNum', localStorageCartInfo.personNum);
          dispatch('addOrderFoodsToCart', localStorageCartInfo.foodsInCart);
        }
      }
    },

    // 设置就餐人数并检查必选菜品
    changePersonNum: function changePersonNum(_ref3, personNum) {
      var commit = _ref3.commit,
          state = _ref3.state;

      commit('setPersonNum', personNum);
      if (state.paidOrderIdWithin2Hours !== '' || Object(__WEBPACK_IMPORTED_MODULE_11_src_components_api_interface_hhy__["p" /* getUserIdentity */])('businessType') !== __WEBPACK_IMPORTED_MODULE_12_src_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */]) {
        return;
      }
      var _iteratorNormalCompletion18 = true;
      var _didIteratorError18 = false;
      var _iteratorError18 = undefined;

      try {
        for (var _iterator18 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(state.requiredFoods), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
          var food = _step18.value;

          var foodCountLimit = food.countLimit === state.appConst.FOOD_REQUIRED_PERPEOPLE ? personNum : 1,
              branchDish = state.mqMessagePayLoad && state.mqMessagePayLoad.dish ? state.mqMessagePayLoad.dish : [],
              orderFoods = state.foodsInCart.concat(branchDish),
              orderFoodCount = 0;
          var _iteratorNormalCompletion19 = true;
          var _didIteratorError19 = false;
          var _iteratorError19 = undefined;

          try {
            for (var _iterator19 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_get_iterator___default()(orderFoods), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
              var orderFood = _step19.value;

              if (orderFood.id && orderFood.id === food.id) {
                // 购物车点菜
                orderFoodCount += orderFood.count;
              } else if (orderFood.goodsName === food.name) {
                // 门店点菜
                orderFoodCount += orderFood.num;
              }
            }
          } catch (err) {
            _didIteratorError19 = true;
            _iteratorError19 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion19 && _iterator19.return) {
                _iterator19.return();
              }
            } finally {
              if (_didIteratorError19) {
                throw _iteratorError19;
              }
            }
          }

          if (orderFoodCount < foodCountLimit) {
            __WEBPACK_IMPORTED_MODULE_6_vue___default.a.set(food, 'addCount', foodCountLimit - orderFoodCount);
            commit('addFoodsToCart', food);
          }
        }
      } catch (err) {
        _didIteratorError18 = true;
        _iteratorError18 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion18 && _iterator18.return) {
            _iterator18.return();
          }
        } finally {
          if (_didIteratorError18) {
            throw _iteratorError18;
          }
        }
      }
    },

    // 清空购物车，切记这是个异步操作，应用actions而不是mutations
    setCartEmpty: function setCartEmpty(_ref4) {
      var commit = _ref4.commit;

      __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_message_box___default.a.confirm('清空购物车?', '提示').then(function (action) {
        commit('setCartEmptySilent');
      });
    },
    // 拉取门店点餐信息
    // pullBranchMsg ({commit}) {
    //   return new Promise((resolve, reject) => {
    //     mnsBranchTableMsg().then(data => {
    //       let res = JSON.parse(data);
    //       commit('setBranchMessagePayLoad', res);
    //       resolve(res);
    //     }).catch(err => {
    //       reject(err);
    //     });
    //   });
    // },
    /**
     * 链接mq消息通道
     */
    mqConnect: function mqConnect(_ref5) {
      var commit = _ref5.commit,
          state = _ref5.state;
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (state.mqConnectStatus === __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["c" /* CONNECT_STATUS_SUCCESS */] && force === false) {
        return;
      }
      if (state.mqConnectStatus === __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["c" /* CONNECT_STATUS_SUCCESS */]) {
        commit('setMqConnectStatus', __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["d" /* CONNECT_STATUS_WAITTING */]);
      }
      var mqClient = Object(__WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["e" /* createClient */])(),
          connectOptions = Object(__WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["f" /* createConnectOptions */])();
      // 收到通知
      mqClient.onMessageArrived = function (message) {
        console.log('收到mqtt消息', message);
        var payload = message.payloadString,
            payloadObj = JSON.parse(payload);
        commit('setMqMessagePayLoad', payloadObj);
      };
      // 断开链接
      mqClient.onConnectionLost = function (response) {
        console.error('mqtt断开链接');
        commit('setMqConnectStatus', __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["b" /* CONNECT_STATUS_LOST */]);
      };

      var clientId = mqClient.clientId,
          requestIdIndex = mqClient.clientId.indexOf('@@@') + 3,
          requestId = clientId.substring(requestIdIndex);
      commit('setMqRequestId', requestId);
      // 链接成功
      connectOptions.onSuccess = function () {
        console.log('mqtt链接成功');
        Object(__WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["g" /* onConnect */])(mqClient);
        commit('setMqConnectStatus', __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["c" /* CONNECT_STATUS_SUCCESS */]);
      };
      // 链接失败
      connectOptions.onFailure = function () {
        console.error('mqtt链接失败');
        commit('setMqConnectStatus', __WEBPACK_IMPORTED_MODULE_14_src_common_mqtt_mqtt__["a" /* CONNECT_STATUS_FAIL */]);
      };
      // 建立链接
      mqClient.connect(connectOptions);
    }
  },
  modules: {
    appConst: __WEBPACK_IMPORTED_MODULE_8__store_const_js__["a" /* default */],
    appUtils: __WEBPACK_IMPORTED_MODULE_9__store_utils_js__["a" /* default */]
  }
}));

/***/ }),

/***/ "K390":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "welcome-wrapper" },
    [
      [
        _c("img", {
          staticClass: "welcome-main",
          attrs: { src: _vm.images[0], alt: "" }
        }),
        _vm._v(" "),
        _c("img", {
          staticClass: "welcome-secondary",
          attrs: { src: _vm.images[1], alt: "" }
        })
      ],
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "hide-btn",
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.hideImg($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.seconds) + " 跳过")]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fdcedba4", esExports)
  }
}

/***/ }),

/***/ "KHum":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

// vuex模块：工具方法
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    /**
     * 套餐菜已选菜品以id-specId为键值的对象
     * @param suitFood 套餐菜
     * @return {{}}
     */
    getSuitCartDetailsMapById: function getSuitCartDetailsMapById(suitFood) {
      var details = {};
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(suitFood.foodSuitGroups), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var group = _step.value;
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(group.cartDetails), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var detailFood = _step2.value;

              var key = detailFood.id + '-' + detailFood.specId;
              details[key] = detailFood;
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return details;
    }
  }
});

/***/ }),

/***/ "M/o6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CONNECT_STATUS_WAITTING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CONNECT_STATUS_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONNECT_STATUS_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONNECT_STATUS_LOST; });
/* harmony export (immutable) */ __webpack_exports__["e"] = createClient;
/* harmony export (immutable) */ __webpack_exports__["f"] = createConnectOptions;
/* harmony export (immutable) */ __webpack_exports__["g"] = onConnect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_paho_mqtt__ = __webpack_require__("C7DB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_paho_mqtt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_paho_mqtt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js__ = __webpack_require__("Av7u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_api_interface_hhy__ = __webpack_require__("UZDt");





// 链接状态
var CONNECT_STATUS_WAITTING = 'waitting';
var CONNECT_STATUS_SUCCESS = 'success';
var CONNECT_STATUS_FAIL = 'fail';
var CONNECT_STATUS_LOST = 'lost';
/**
 * 创建Paho.MQTT.Client
 * @return {Paho.Client}
 */
function createClient() {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_3_src_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var client = new __WEBPACK_IMPORTED_MODULE_0_paho_mqtt___default.a.Client(__WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].host, // MQTT域名
  __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].port, // WebSocket端口，如果使用HTTPS加密则配置为443,否则配置80
  __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].groupId + '@@@' + userIdentity.branchId + userIdentity.userId + userIdentity.tableNo // 客户端ClientId
  );
  return client;
}

/**
 * 生成链接配置信息
 * @param client
 * @return {{userName: string, password: (string|*), useSSL: boolean, timeout: number, onSuccess: onSuccess, onFailure: onFailure}}
 */
function createConnectOptions() {
  var password = __WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.HmacSHA1(__WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].groupId, __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].secretKey).toString(__WEBPACK_IMPORTED_MODULE_1_crypto_js___default.a.enc.Base64);
  var options = {
    userName: __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].accessKey,
    password: password,
    useSSL: __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].useTLS,
    timeout: 3
  };

  return options;
}

/**
 * 成功连接
 * Connection succeeded; subscribe to our topic
 * @param {Paho.MQTT.Client} mqtt
 */
function onConnect(mqtt) {
  var topic = __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["j" /* MQTT_CONFIG */].topic;
  mqtt.subscribe(topic, { qos: 0 });
}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("Ty93");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("ccwP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ba5bd90_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/App.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7ba5bd90", Component.options)
  } else {
    hotAPI.reload("data-v-7ba5bd90", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MTb8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["n"] = setLocalUserIdentity;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return APP_ENV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return INTERACE_MERCHANT_CENTER_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return INTERACE_SAAS_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return INTERACE_SAAS_ORDER_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTERACE_BRANCH_PULL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INTERACE_HHY_BASE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return INTERFACE_GATEWAY_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return MEMBER_RECHARGE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MEMBER_REGISTE_URL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MQTT_CONFIG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return QQ_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return STEP_FREIGHT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return USERCARD_TIME_LIMIT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_api_interface_saas__ = __webpack_require__("qkUO");
/**
 * 全局常量定义
 * @author ytl
 */

// local 本地 ；server服务器；打包时，请切换到server模式


var appEnv = 'server';
// 商户中心接口
var interfaceMemberCenter = 'http://www.hocyun.com.cn:8889/v1';
// saas接口地址
// let interfaceSaasBase = 'http://localhost:5008/v1';
var interfaceSaasBase = 'http://www.hocyun.com.cn:9100/v1';
// saas订单接口地址
var interfaceSaasOrder = 'http://www.hocyun.com.cn:9200/v1';
// 门店端信息拉取接口
var interfaceBranchPull = 'http://www.hocyun.com.cn:7002/v1';
// 好会员接口地址
var interfaceHhy = 'https://crm.hocyun.com.cn/api-app/v1';
// 网关接口
var interfaceGateWay = 'https://api-gateway.hocyun.com.cn';
// 好会员充值地址
var memberRechargeUrl = 'https://crm.hocyun.com.cn/weixinMarketing/frontend/web/index.php/member/pay/member-recharge?';
// 成为会员地址
var memberRegUrl = 'https://crm.hocyun.com.cn/weixinMarketing/frontend/web/index.php/member/pay/member-perfect?';

/**
 * mq配置
 * host = 'XXX.mqtt.aliyuncs.com';// 设置当前用户的接入点域名，接入点获取方法请参考接入准备章节文档，先在控制台申请实例
 port = 80;//WebSocket协议服务端口，如果是走HTTPS，设置443端口
 topic = 'XXXXXXX';//需要操作的Topic
 useTLS = false;//是否走加密HTTPS，如果走HTTPS，设置为true
 accessKey = 'XXXXXX';//账号的AccessKey，在阿里云控制台查看
 secretKey = 'XXXXXX=';//账号的的SecretKey，在阿里云控制台查看
 cleansession = true;
 groupId='GID_XXXX';
 clientId=groupId+'@@@XXXX';//GroupId@@@DeviceId，由控制台申请的Group ID和自己指定的Device ID组合构成
 */
var mqttConfig = {
  host: 'mqtt-cn-4590nhpl005.mqtt.aliyuncs.com',
  port: 443,
  topic: 'hshk_common_lmq',
  useTLS: true,
  accessKey: 'LTAIfhVaJOSaDHN4',
  secretKey: 'P5qo5mh48ayPrKWG5rsgfMkDPYChDB',
  cleansession: true,
  groupId: 'GID_common_lmq'
};

// 阶梯运费
var stepFreight = {
  '5823': [{ min: 0, max: 50, amount: 9 }, { min: 50, max: 100, amount: 6 }]
};

// 时间区间用券限制uid:[开始时间毫秒，结束时间毫秒]
var userCardTimeLimit = {
  '5320': [1601438399000, 1601481599000]

  // PROSESS_ENV是由DefinePlugin定义的环境变量
};if (false) {
  appEnv = 'local';
}
if (true) {
  // 测试环境
  // 商户中心接口
  interfaceMemberCenter = 'https://d.hocyun.com.cn/api/org';
  // saas接口地址
  interfaceSaasBase = 'https://d.hocyun.com.cn/api/base';
  // saas订单接口地址
  interfaceSaasOrder = 'https://d.hocyun.com.cn/api/order';
  // 门店端信息拉取接口
  interfaceBranchPull = 'https://d.hocyun.com.cn/api/branch';
} else if (PROSESS_ENV === 'production') {
  // 生成环境
  // 商户中心接口
  interfaceMemberCenter = 'https://org.hocyun.com/v1';
  // saas接口地址
  interfaceSaasBase = 'https://base.hocyun.com/v1';
  // saas订单接口地址
  interfaceSaasOrder = 'https://order.hocyun.com/v1';
  // 门店端信息拉取接口
  interfaceBranchPull = 'https://branch.hocyun.com/v1';
  // 好会员接口地址
  interfaceHhy = 'https://crm.hocyun.com/api-app/v1';
  // 网关接口
  interfaceGateWay = 'https://api-gateway.hocyun.com';
  // 好会员充值地址
  memberRechargeUrl = 'https://crm.hocyun.com/weixinMarketing/frontend/web/index.php/member/pay/member-recharge?';
  // 成为会员地址
  memberRegUrl = 'https://crm.hocyun.com/weixinMarketing/frontend/web/index.php/member/pay/member-perfect?';
  mqttConfig = {
    host: 'mqtt-cn-4590nhpl005.mqtt.aliyuncs.com',
    port: 443,
    topic: 'hshk_common_lmq',
    useTLS: true,
    accessKey: 'LTAI4GKFRs6vrxhWf46B91NF',
    secretKey: 'rKTxp798cj9gK2sUFiSht7SXLRDkqO',
    cleansession: true,
    groupId: 'GID_common_lmq'
  };
  stepFreight = {
    '167': [{ min: 0, max: 50, amount: 9 }, { min: 50, max: 100, amount: 6 }]
  };
  userCardTimeLimit = {
    '106': [1601481600000, 1602172799000]
  };
}
function setLocalUserIdentity(_businessType) {
  var localUserIdentity = {
    businessType: _businessType || __WEBPACK_IMPORTED_MODULE_1_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */],
    orgId: 5823,
    uid: 5320,
    authId: 197,
    branchId: 10068,
    tableId: 0,
    tableNo: '101',
    userId: 1568344,
    showname: 'zfd',
    mobile: '17076020409',
    levelType: 'REGISTE',
    userThirdValue: 'oFlJft1R4Q_EXSh-JiNaxSbBF7zQ',
    appId: 'wx32f81502193d6653',
    isJC: 'NO'
    // menuType: 'TSEX'
    // tableName: '梦之谷',
    // entry: 'aliShopPage'   // 支付宝门店页进入
  };
  Object(__WEBPACK_IMPORTED_MODULE_0_components_api_utils__["t" /* setSessionStorageItem */])('userIdentity', localUserIdentity);
  return localUserIdentity;
};
var APP_ENV = appEnv;
var INTERACE_MERCHANT_CENTER_BASE_URL = interfaceMemberCenter;
var INTERACE_SAAS_BASE_URL = interfaceSaasBase;
var INTERACE_SAAS_ORDER_BASE_URL = interfaceSaasOrder;
var INTERACE_BRANCH_PULL = interfaceBranchPull;
var INTERACE_HHY_BASE_URL = interfaceHhy;
var INTERFACE_GATEWAY_URL = interfaceGateWay;
var MEMBER_RECHARGE_URL = memberRechargeUrl;
var MEMBER_REGISTE_URL = memberRegUrl;
var MQTT_CONFIG = mqttConfig;
var QQ_MAP = {
  app: '好易点-外送-H5',
  key: 'KYHBZ-I4YC3-7SU3J-YMC7V-DYON7-QMFBY'
};
var STEP_FREIGHT = stepFreight;
var USERCARD_TIME_LIMIT = userCardTimeLimit;

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__ = __webpack_require__("d8/S");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_mint_ui_lib_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib__ = __webpack_require__("clQT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_mint_ui_lib___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill__ = __webpack_require__("j1ja");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_router_config__ = __webpack_require__("pkiq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_store_config__ = __webpack_require__("G4VM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_lazyload__ = __webpack_require__("AXdl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__ = __webpack_require__("qkUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_meta_info__ = __webpack_require__("5K15");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_meta_info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_meta_info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__config_params__ = __webpack_require__("m+LJ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_src_filter_index__ = __webpack_require__("bbc5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_api_interface_saas__ = __webpack_require__("qkUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_api_interface_merchant_center__ = __webpack_require__("RHqD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_api_interface_saas_order__ = __webpack_require__("mvSL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_src_components_api_weixin_jsapi__ = __webpack_require__("9qvX");






/**
 * 业务前置判断
 * @param {Object} to
 * @param {Function} next
 * @param {Boolean} login 是否是新登录操作，用于判断首页是goods还是home
 * @private
 */
var _beforeEach = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, next) {
    var login = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var userIdentity, businessType, branchId, businessInfo, index, setting, takeCardsRoutes, haveTable, tableInfo, _tableInfo$id, tableId, _tableInfo$tableName, tableName, _tableInfo$tableNo, tableNo, _tableInfo$deleted, deleted, _tableInfo$disabled, disabled, clientType, isFromAliApp, preOrder;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            userIdentity = Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["p" /* getUserIdentity */])();

            if (!(to.name === 'alipayWithOutOrder')) {
              _context.next = 4;
              break;
            }

            // 码上付-买单
            next();
            return _context.abrupt('return');

          case 4:
            businessType = to.query.businessType ? to.query.businessType : userIdentity.businessType;

            if (to.query.userId) {
              // 好会员回跳，会员信息发生变更
              Object(__WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["q" /* getUserInfoByUserId */])(to.query.userId).then(function (data) {
                var id = data.id,
                    showname = data.showname,
                    mobile = data.mobile,
                    levelType = data.levelType;

                Object(__WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["B" /* updateUserIdentity */])('', {
                  userId: id,
                  showname: showname,
                  mobile: mobile,
                  levelType: levelType
                });
              }).catch(function () {
                next({ name: 'error', params: { message: '查询会员信息失败' } });
              });
            }

            if (!(to.name === 'feedback')) {
              _context.next = 9;
              break;
            }

            next();
            return _context.abrupt('return');

          case 9:
            // 登录操作、单门店业务验证业务是否开通、查询业务设置参数
            branchId = to.params.branchId || userIdentity.branchId;

            if (!(login === true && branchId && businessType !== 'MEMBER')) {
              _context.next = 29;
              break;
            }

            if (!(to.name !== 'aliScanPay')) {
              _context.next = 22;
              break;
            }

            _context.next = 14;
            return Object(__WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["n" /* getBranchBusinessInfo */])(branchId).catch(function () {});

          case 14:
            businessInfo = _context.sent;

            if (businessInfo) {
              _context.next = 18;
              break;
            }

            next({ name: 'error', params: { message: '暂未启用此功能,可联系店内工作人员' } });
            return _context.abrupt('return');

          case 18:
            index = businessInfo.findIndex(function (item) {
              return item.businessType === businessType && item.status === __WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["c" /* BUSINESS_TYPE_STATUS_OPEN */];
            });

            if (!(index === -1)) {
              _context.next = 22;
              break;
            }

            next({ name: 'error', params: { message: '暂未启用此功能,可联系店内工作人员' } });
            return _context.abrupt('return');

          case 22:
            _context.next = 24;
            return Object(__WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["p" /* getBusinessSetting */])().catch(function () {});

          case 24:
            setting = _context.sent;

            if (setting) {
              _context.next = 28;
              break;
            }

            next({ name: 'error', params: { message: '业务设置参数查询错误' } });
            return _context.abrupt('return');

          case 28:
            __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setBusinessSetting', setting);

          case 29:
            // 查询是否有领券下单活动
            takeCardsRoutes = ['goods', 'aliScanPay', 'home', 'distribution'];

            takeCardsRoutes = []; // 没有使用的
            if (!takeCardsRoutes.includes(to.name) || __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].state.takeCardsSearch) {
              __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setTakeCardsModalVisible', false);
            } else if (branchId && !__WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].state.takeCardsBranchIds.includes(branchId)) {
              Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["j" /* getCouponActivity */])().then(function (res) {
                if (res && res.length > 0) {
                  __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setTakeCardsArr', res);
                  __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setTakeCardsModalVisible', true);
                }
              }).catch(function (err) {
                console.error(err);
              });
              __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setTakeCardsSearch', true);
            }
            _context.t0 = businessType;
            _context.next = _context.t0 === __WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] ? 35 : 65;
            break;

          case 35:
            haveTable = userIdentity.tableNo || userIdentity.tableId;
            // 查询桌台信息

            if (!(haveTable && 'tableName' in userIdentity === false)) {
              _context.next = 48;
              break;
            }

            _context.next = 39;
            return Object(__WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["v" /* getTableInfo */])().catch(function () {});

          case 39:
            tableInfo = _context.sent;

            if (tableInfo) {
              _context.next = 43;
              break;
            }

            next({ name: 'error', params: { message: '当前桌台不可用' } });
            return _context.abrupt('return');

          case 43:
            _tableInfo$id = tableInfo.id, tableId = _tableInfo$id === undefined ? 0 : _tableInfo$id, _tableInfo$tableName = tableInfo.tableName, tableName = _tableInfo$tableName === undefined ? '' : _tableInfo$tableName, _tableInfo$tableNo = tableInfo.tableNo, tableNo = _tableInfo$tableNo === undefined ? '' : _tableInfo$tableNo, _tableInfo$deleted = tableInfo.deleted, deleted = _tableInfo$deleted === undefined ? 'YES' : _tableInfo$deleted, _tableInfo$disabled = tableInfo.disabled, disabled = _tableInfo$disabled === undefined ? 'YES' : _tableInfo$disabled;

            if (!(deleted === 'YES' || disabled === 'YES')) {
              _context.next = 47;
              break;
            }

            next({ name: 'error', params: { message: '当前桌台不可用' } });
            return _context.abrupt('return');

          case 47:
            Object(__WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["B" /* updateUserIdentity */])('', { tableId: tableId, tableNo: tableNo, tableName: tableName });

          case 48:
            if (!(login === true)) {
              _context.next = 63;
              break;
            }

            if (!(to.name !== 'aliScanPay')) {
              _context.next = 53;
              break;
            }

            if (!(!haveTable && !branchId)) {
              _context.next = 53;
              break;
            }

            next({ name: 'stores' });
            return _context.abrupt('return');

          case 53:
            // 微信后支付或者预点餐下单跳转首页
            clientType = Object(__WEBPACK_IMPORTED_MODULE_12_components_api_utils__["k" /* getClientType */])(), isFromAliApp = clientType === __WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["a" /* CLIENT_ALIPAY */] && (to.query.merchant_pid && to.query.shop_id || to.query.biz_type === 'alipay');

            isFromAliApp && Object(__WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["B" /* updateUserIdentity */])('entry', 'aliShopPage'); // 入口为支付宝门店页

            if (!(!isFromAliApp && (to.name === 'goods' || to.path === '/'))) {
              _context.next = 62;
              break;
            }

            _context.next = 58;
            return Object(__WEBPACK_IMPORTED_MODULE_21__components_api_interface_saas_order__["m" /* getUserPreOrderSummary */])().catch(function (err) {
              console.error(err);
            });

          case 58:
            preOrder = _context.sent;

            if (!(__WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].state.businessSetting.checkMode !== __WEBPACK_IMPORTED_MODULE_19__components_api_interface_saas__["k" /* TS_PAY_TYPE_BEFORE */] || preOrder && preOrder.orderId)) {
              _context.next = 62;
              break;
            }

            next({ name: 'home' });
            return _context.abrupt('return');

          case 62:
            if (to.path === '/') {
              next({ name: 'goods' });
            }

          case 63:
            next();
            return _context.abrupt('break', 66);

          case 65:
            next();

          case 66:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function _beforeEach(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * 口碑服务地址path处理
 * @param defaultPath 默认地址path
 * @private
 */













 // 用于处理页面title和关键词等








__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_mint_ui_lib___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_15_vue_meta_info___default.a);
__WEBPACK_IMPORTED_MODULE_6_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_10_vue_lazyload__["a" /* default */], {
  preLoad: 1.3,
  error: '/static/img/default.png',
  loading: '/static/img/loading33.gif',
  attempt: 1
});

// 全局导航钩子
__WEBPACK_IMPORTED_MODULE_8__config_router_config__["a" /* default */].beforeEach(function (to, from, next) {
  var clientType = Object(__WEBPACK_IMPORTED_MODULE_12_components_api_utils__["k" /* getClientType */])();
  if (clientType === '') {
    next({ name: 'error', params: { message: '请在微信或支付宝内打开页面' } });
    return;
  }
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["p" /* getUserIdentity */])();
  // 返回到根路径时关闭网页窗口
  if (userIdentity && to.path === '/') {
    if (clientType === __WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["b" /* CLIENT_WECHAT */]) {
      Object(__WEBPACK_IMPORTED_MODULE_22_src_components_api_weixin_jsapi__["a" /* wxCloseWindow */])();
    }
    return;
  }
  // 二合一码关注消息判断链接是否过期
  var expireSeconds = to.query.expire,
      nowMilliseconds = new Date().getTime();
  if (expireSeconds && nowMilliseconds > expireSeconds * 1000) {
    next({ name: 'error2', params: { title: '页面已过期', label: '请重新扫码打开' } });
    return;
  }
  if (to.name === 'feedback' && !to.query.shop_id) {
    next({ name: 'error', params: { message: '门店信息缺失' } });
    return;
  }
  if (__WEBPACK_IMPORTED_MODULE_17__config_params__["a" /* ROUTES_WITHOUT_IDENTITY */].includes(to.name)) {
    next();
    return;
  }
  var toQuery = to.query;
  // 测试
  if (__WEBPACK_IMPORTED_MODULE_14__config_params_local__["a" /* APP_ENV */] !== 'server' && !userIdentity) {
    Object(__WEBPACK_IMPORTED_MODULE_14__config_params_local__["n" /* setLocalUserIdentity */])(to.query.businessType);
    // 显示欢迎页
    __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setWelcomeImgVisible', true);
    _beforeEach(to, next, true);
    return;
  }
  // 入口1：扫描口碑门店码 /?merchant_pid=&shop_id= : 调起支付宝扫一扫
  // 入口2：扫码点餐(扫口碑码) /?merchant_pid=&shop_id=&user_id=&table_num=
  // 入口3：扫码点餐(扫好客云桌台码)  /?#/goods?org_id=&shop_id=&table_num=
  // 入口4：外卖/预约自取/预约堂食/订单中心 /?#/stores(或member)?authId=&businessType=
  // 入口5：取得授权code后跳转回来
  // 入口6：支付宝调起订单详情页(目前扫码点餐订单详情页无业务交互操作, 可直接显示) /?#/orderDetail/orderId/branchId
  // 入口7：支付宝码码上付右下角[买单] /?biz_type=online_pay&table_num=&merchant_pid=&shop_id=&user_id=
  // 入口8：支付宝码码上付card位[买单] /?biz_type=online_pay&table_num=&merchant_pid=&shop_id
  // 入口9：支付宝码码上付card位[订单详情] /#/aliScanOrderDetail?outTradeNo=
  // 入口10: 微信预点餐：/?#/stores?authId=179
  // 入口11： 支付宝预点餐（扫口碑门店码）/?merchant_pid=&shop_id=&user_id=&table_num=空

  // 入口6
  if (to.name === 'orderDetail' && (!to.params.branchId || !to.params.orderId)) {
    next({ name: 'error', params: { message: '页面参数错误' } });
    return;
  }
  // '?#'丢失'?'
  var checkUrl = _checkUrl();
  if (checkUrl !== '') {
    window.location.href = checkUrl;
    next(false);
    return;
  }
  // 已登录
  if (userIdentity) {
    _beforeEach(to, next);
    return;
  }
  // http://d.hocyun.cn/custom/?merchant_pid=&shop_id=&user_id=&table_num=&...
  // 口碑门店插件访问时丢失(?#), 造成to.query参数无法获取
  if (__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(toQuery).length === 0 && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(to.params).length === 0) {
    var path = _getAliServiceRouterPath(to.path);
    window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname + '?#' + path + window.location.search;
    next(false);
    return;
  }
  var businessType = void 0;
  var menuType = void 0;
  if (toQuery.menuType) {
    menuType = toQuery.menuType;
  }
  if (toQuery.businessType) {
    businessType = toQuery.businessType;
  } else if (to.name === 'orderDetail') {
    businessType = 'MEMBER';
  } else {
    businessType = __WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */];
  }
  var tableNum = toQuery.table_num || '',
      tableId = toQuery.table_id || 0,
      authCode = toQuery.code,
      isFromAliTs = clientType === __WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["a" /* CLIENT_ALIPAY */] && businessType === __WEBPACK_IMPORTED_MODULE_13_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && toQuery.merchant_pid && toQuery.shop_id,
      // 支付宝接入的扫码点餐
  isFromAliWithUserId = isFromAliTs && toQuery.user_id,
      // 支付宝口碑码扫码接入扫码点餐，并提供了正确的支付宝用户id
  isFromAliWithoutUserId = isFromAliTs && !toQuery.user_id; // 支付宝口碑码扫码接入扫码点餐，未提供支付宝用户id
  if (authCode) {
    // 入口5: 取得授权code后跳转回来
    var branchId = to.name === 'orderDetail' ? to.params.branchId : toQuery.shop_id ? toQuery.shop_id : 0,
        authParams = {
      code: authCode,
      state: toQuery.state,
      appid: toQuery.appid ? toQuery.appid : ''
    },
        params = {
      branchId: branchId,
      tableId: tableId,
      tableNo: tableNum,
      businessType: businessType,
      clientType: clientType,
      authId: toQuery.authId ? toQuery.authId : '',
      isJC: toQuery.isJC ? toQuery.isJC : 'NO',
      menuType: menuType
    };
    Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["v" /* initUserIdentity */])(params, authParams).then(function (res) {
      // 显示欢迎页
      __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */].commit('setWelcomeImgVisible', true);
      // 业务前置判断
      _beforeEach(to, next, true);
    }).catch(function (err) {
      next({ name: 'error', params: { message: err.message || '获取会员失败' } });
    });
  } else if (isFromAliWithUserId) {
    // 入口2: 扫码口碑码
    var _params = {
      thirdChannel: clientType,
      userThirdValue: toQuery.user_id,
      merchant: toQuery.merchant_pid,
      shop: toQuery.shop_id,
      businessType: businessType,
      tableNo: tableNum
    };
    Object(__WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["o" /* getUserByThirdChannelInfo */])(_params).then(function (res) {
      if (toQuery.biz_type === 'online_pay') {
        // 支付宝买单
        var nextConfig = { name: 'aliScanPay' };
        next(nextConfig);
        return;
      }
      if (!res.id) {
        // 新会员需要授权获取信息的情况
        var _path = _getAliServiceRouterPath(to.path);
        var backUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?#' + _path + '?org_id=' + res.orgId + '&shop_id=' + res.branchId + '&table_num=' + tableNum,
            _params2 = {
          branchId: res.branchId,
          businessType: businessType,
          clientType: clientType,
          authId: res.authId
        };
        var authUrl = Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["i" /* getAuthCodeUrl */])(_params2, backUrl);
        window.location.href = authUrl;
        next(false);
      } else {
        // 业务前置判断
        _beforeEach(to, next, true);
      }
    }).catch(function (err) {
      next({ name: 'error', params: { message: err.message || '获取会员失败' } });
    });
  } else if (isFromAliWithoutUserId) {
    // 入口8
    Object(__WEBPACK_IMPORTED_MODULE_20__components_api_interface_merchant_center__["a" /* getBranchInfoByAliShopId */])(toQuery.shop_id).then(function (data) {
      var branchId = data.branchId,
          backUrl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?#' + _getAliServiceRouterPath(to.path) + '?shop_id=' + branchId + '&table_num=' + tableNum + '&biz_type=alipay',
          params = {
        branchId: branchId,
        businessType: businessType,
        clientType: clientType,
        authId: 0
      };
      var authUrl = Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["i" /* getAuthCodeUrl */])(params, backUrl);
      window.location.href = authUrl;
      next(false);
    }).catch(function (err) {
      console.log(err);
      next({ name: 'error', params: { message: '未查询到对应门店' } });
    });
  } else {
    // 入口3/4/6: 直接走授权
    var _branchId = to.name === 'orderDetail' ? to.params.branchId : toQuery.shop_id ? toQuery.shop_id : 0,
        urlSep = window.location.hash.indexOf('?') === -1 ? '?' : '&',
        backUrl = to.name !== 'orderDetail' ? window.location.href : window.location.href + urlSep + 'shop_id=' + _branchId;
    var _params3 = {
      branchId: _branchId,
      businessType: businessType,
      clientType: clientType,
      authId: toQuery.authId ? toQuery.authId : 0
    };
    var authUrl = Object(__WEBPACK_IMPORTED_MODULE_11_components_api_interface_hhy__["i" /* getAuthCodeUrl */])(_params3, backUrl);
    window.location.href = authUrl;
    next(false);
  }
});

// 微信端全页面禁用右上角分享菜单
__WEBPACK_IMPORTED_MODULE_8__config_router_config__["a" /* default */].afterEach(function () {
  if (Object(__WEBPACK_IMPORTED_MODULE_12_components_api_utils__["k" /* getClientType */])() === __WEBPACK_IMPORTED_MODULE_16__components_api_interface_hhy__["b" /* CLIENT_WECHAT */]) {
    Object(__WEBPACK_IMPORTED_MODULE_22_src_components_api_weixin_jsapi__["b" /* wxDisableShareMenu */])();
  }
});function _getAliServiceRouterPath(defaultPath) {
  var search = window.location.search;
  if (search.indexOf('biz_type=online_pay') !== -1) {
    // 买单
    return '/aliScanPay';
  }
  return defaultPath;
}

/**
 * 检查当前url中是否有?#（防止nginx重定向后?#变成#）
 * @return {*}
 * @private
 */
function _checkUrl() {
  var currentHref = window.location.href;
  if (currentHref.indexOf('#') !== -1 && currentHref.indexOf('?#') === -1) {
    return currentHref.replace('#', '?#');
  }
  return '';
}

new __WEBPACK_IMPORTED_MODULE_6_vue___default.a({
  router: __WEBPACK_IMPORTED_MODULE_8__config_router_config__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__config_store_config__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */]
  },
  data: {
    eventHub: new __WEBPACK_IMPORTED_MODULE_6_vue___default.a()
  }
}).$mount('#app');

/***/ }),

/***/ "OgVB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PeiJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "take-card" }, [
    _c("div", { staticClass: "left" }, [
      _c("div", [
        _vm._v("¥"),
        _c("span", { staticClass: "amount" }, [_vm._v(_vm._s(_vm.reduceCost))])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "num" }, [
        _vm._v("×" + _vm._s(_vm.card.num || 1))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "right" }, [
      _c("div", [_vm._v(_vm._s(_vm.card.title))]),
      _vm._v(" "),
      _c("div", [_vm._v("满" + _vm._s(_vm.card.least_cost) + "元可用")]),
      _vm._v(" "),
      _c("div", [_vm._v(_vm._s(_vm.effectDate))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8308e664", esExports)
  }
}

/***/ }),

/***/ "Pgnm":
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ "RHqD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createHttp */
/* harmony export (immutable) */ __webpack_exports__["b"] = getBranchMapByIdes;
/* harmony export (immutable) */ __webpack_exports__["e"] = getBranchWithDish;
/* harmony export (immutable) */ __webpack_exports__["c"] = getBranchPic;
/* harmony export (immutable) */ __webpack_exports__["d"] = getBranchPics;
/* harmony export (immutable) */ __webpack_exports__["a"] = getBranchInfoByAliShopId;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__ = __webpack_require__("UZDt");

/**
 * 商户中心接口
 * @author ytl
 */






/**
 * 创建axios实例
 * @return {axios}
 */
function createHttp() {
  var $httpMerchant = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_3_src_config_params_local__["d" /* INTERACE_MERCHANT_CENTER_BASE_URL */],
    transformRequest: [function (data) {
      data = __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
      return data;
    }],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

  // 添加一个响应拦截器
  $httpMerchant.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      Object(__WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__["w" /* logging */])({ request: res.config, responseData: res.data });
      var errMsg = { message: res.data.msg || '' };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, function (err) {
    var responseData = err.response ? err.response.data : null;
    Object(__WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__["w" /* logging */])({
      request: err.config,
      responseData: responseData,
      err: responseData ? null : err
    });
    var errorInfo = err.response ? err.response.data : err;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorInfo);
  });
  return $httpMerchant;
}
/**
 * 使用门店编码获取单个/部分门店信息
 * @param branchIdArr 门店编号数组
 */
function getBranchMapByIdes(branchIdArr) {
  var localBranches = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_utils__["l" /* getLocalStorageItem */])('branches') ? Object(__WEBPACK_IMPORTED_MODULE_4_components_api_utils__["l" /* getLocalStorageItem */])('branches') : {};
  var refresh = false;
  if (localBranches) {
    for (var branchId in branchIdArr) {
      if (!localBranches[branchId]) {
        refresh = true;
        break;
      }
    }
    if (refresh === false) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(localBranches);
    }
  }
  var url = '/branches/' + branchIdArr.join(',');
  var $httpMerchant = createHttp();
  $httpMerchant.interceptors.response.use(function (res) {
    for (var rowIndex in res) {
      var row = res[rowIndex];
      var _branchId = row.id;
      localBranches[_branchId] = row;
    }
    Object(__WEBPACK_IMPORTED_MODULE_4_components_api_utils__["s" /* setLocalStorageItem */])('branches', localBranches, 86400);
    return localBranches;
  });

  return $httpMerchant.get(url);
}
/**
 * 自助点餐接口
 * 获取门店列表，带有图片和经纬度
 */
function getBranchWithDish(params) {
  var mapType = 'GD'; // 地图类型高德
  var url = '/branches/uid/' + params.uid + '/appid/' + params.appId + '/businessType/' + params.businessType + '/mapType/' + mapType;
  var $httpMerchant = createHttp();
  return $httpMerchant.get(url);
}

/**
 * 获取门店图片
 * @param {String} branchId
 * @return {Promise}
 */
function getBranchPic(branchId) {
  var url = '/branches/branchStore/branchId/' + branchId;
  return createHttp().get(url);
}

/**
 * 获取门店图片 新
 * @param {String} branchId
 * @return {Promise}
 */
function getBranchPics(branchId) {
  var url = '/branches/branchStoreInfo/branchId/' + branchId;
  return createHttp().get(url);
}
/**
 * GET /v1/branch/auth/alipay/detail
 * 根据支付宝shop_id获取门店信息
 * @param {string} shopId
 * @return {Promise}
 */
function getBranchInfoByAliShopId(shopId) {
  var url = '/branch/auth/alipay/detail?shopId=' + shopId,
      $http = createHttp();
  return $http.get(url);
}

/***/ }),

/***/ "SEB5":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("oYRo");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("530a797c", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14792755\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TakeCardsModal.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-14792755\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TakeCardsModal.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "Ty93":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "containerBox",
      on: { focusout: _vm.inputBlur, focusin: _vm.inputFocus }
    },
    [
      _vm.welcomeImgVisible ? _c("welcome") : _vm._e(),
      _vm._v(" "),
      _c(
        "keep-alive",
        [!_vm.$route.meta.keep ? _c("router-view") : _vm._e()],
        1
      ),
      _vm._v(" "),
      _vm.$route.meta.keep ? _c("router-view") : _vm._e(),
      _vm._v(" "),
      _c("take-cards-modal", { attrs: { visible: _vm.takeCardsModalVisible } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}

/***/ }),

/***/ "UZDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESPONSE_CODE_SUCCESS; });
/* unused harmony export RESPONSE_CODE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CLIENT_WECHAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLIENT_ALIPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return USER_LEVEL_FANS; });
/* unused harmony export USER_LEVEL_REGISTE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return USER_LEVEL_PREPAID; });
/* unused harmony export createHttp */
/* harmony export (immutable) */ __webpack_exports__["i"] = getAuthCodeUrl;
/* harmony export (immutable) */ __webpack_exports__["v"] = initUserIdentity;
/* harmony export (immutable) */ __webpack_exports__["p"] = getUserIdentity;
/* harmony export (immutable) */ __webpack_exports__["B"] = updateUserIdentity;
/* harmony export (immutable) */ __webpack_exports__["q"] = getUserInfoByUserId;
/* harmony export (immutable) */ __webpack_exports__["s"] = getUsercardList;
/* harmony export (immutable) */ __webpack_exports__["l"] = getPointsConfig;
/* harmony export (immutable) */ __webpack_exports__["x"] = sendSmsCode;
/* harmony export (immutable) */ __webpack_exports__["C"] = updateUserInfo;
/* harmony export (immutable) */ __webpack_exports__["g"] = createUserShippingAddress;
/* harmony export (immutable) */ __webpack_exports__["D"] = updateUserShippingAddress;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteUserShippingAddress;
/* harmony export (immutable) */ __webpack_exports__["r"] = getUserShippingAddressList;
/* harmony export (immutable) */ __webpack_exports__["o"] = getUserByThirdChannelInfo;
/* unused harmony export getBranchInfoByAliShopId */
/* unused harmony export getUserRightDesc */
/* harmony export (immutable) */ __webpack_exports__["u"] = ifCardUsable;
/* harmony export (immutable) */ __webpack_exports__["m"] = getRightLevelDetail;
/* harmony export (immutable) */ __webpack_exports__["n"] = getRightLevelDetailByBranch;
/* harmony export (immutable) */ __webpack_exports__["k"] = getPayRules;
/* harmony export (immutable) */ __webpack_exports__["f"] = checkUserSendSmsCode;
/* harmony export (immutable) */ __webpack_exports__["j"] = getCouponActivity;
/* harmony export (immutable) */ __webpack_exports__["z"] = takeActivityCards;
/* harmony export (immutable) */ __webpack_exports__["y"] = submitFeedback;
/* harmony export (immutable) */ __webpack_exports__["w"] = logging;
/* unused harmony export userCardConsumeLogs */
/* harmony export (immutable) */ __webpack_exports__["A"] = timeSpanCardConsumeLog;
/* harmony export (immutable) */ __webpack_exports__["t"] = getWelcomeImage;
/* unused harmony export tableStatus */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_api_utils__ = __webpack_require__("X623");



/**
 * 好会员接口相关
 * @author ytl
 */






// 接口自定义code状态
var RESPONSE_CODE_SUCCESS = 'SUCCESS';
var RESPONSE_CODE_FAIL = 'FAIL';

// 客户端类型
var CLIENT_WECHAT = 'WECHAT'; // 微信
var CLIENT_ALIPAY = 'ALIPAY'; // 支付宝

// 会员类型
var USER_LEVEL_FANS = 'FANS'; // 粉丝
var USER_LEVEL_REGISTE = 'REGISTE'; // 注册会员
var USER_LEVEL_PREPAID = 'PREPAID'; // 储值会员会员

/**
 * 创建axios实例
 * @return {axios}
 */
function createHttp() {
  var $httpHhy = __WEBPACK_IMPORTED_MODULE_4_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_5_src_config_params_local__["c" /* INTERACE_HHY_BASE_URL */],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

  $httpHhy.interceptors.response.use(function (res) {
    return res.data;
  }, function (err) {
    var url = err.request ? err.request.url : '';
    if (url !== '/log/we-app') {
      var responseData = err.response ? err.response.data : null;
      logging({
        request: err.config,
        responseData: responseData,
        err: responseData ? null : err
      });
    }
    var errorInfo = err.response ? err.response.data : err;
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(errorInfo);
  });
  return $httpHhy;
}

/**
 * 获取code url
 * @param params
 * @return {String}
 */
function getAuthCodeUrl(params, backUrl) {
  var branchId = params.branchId,
      clientType = params.clientType,
      businessType = params.businessType,
      _params$authId = params.authId,
      authId = _params$authId === undefined ? '' : _params$authId;


  var url = __WEBPACK_IMPORTED_MODULE_5_src_config_params_local__["c" /* INTERACE_HHY_BASE_URL */] + '/get-code/branch_id/' + branchId + '/client_type/' + clientType + '/business_type/' + businessType + '/auth_id/' + authId;
  url += '?back_uri=' + encodeURIComponent(backUrl);
  return url;
}

/**
 * 初始化会员信息
 * @param {Object} params 请求参数
 * @param {Object} authQuery 微信/支付宝授权信息（code、state、appid）
 * @return {Promise}
 */
function initUserIdentity(params, authQuery) {
  var _params$branchId = params.branchId,
      branchId = _params$branchId === undefined ? 0 : _params$branchId,
      clientType = params.clientType,
      businessType = params.businessType,
      _params$authId2 = params.authId,
      authId = _params$authId2 === undefined ? '' : _params$authId2,
      _params$tableId = params.tableId,
      tableId = _params$tableId === undefined ? 0 : _params$tableId,
      _params$tableNo = params.tableNo,
      tableNo = _params$tableNo === undefined ? 0 : _params$tableNo,
      _params$isJC = params.isJC,
      isJC = _params$isJC === undefined ? 'NO' : _params$isJC,
      _params$menuType = params.menuType,
      menuType = _params$menuType === undefined ? '' : _params$menuType;


  var url = '/user/branch_id/' + branchId + '/client_type/' + clientType + '/business_type/' + businessType + '/auth_id/' + authId;

  url += '?' + __WEBPACK_IMPORTED_MODULE_3_qs___default.a.stringify(authQuery);

  var $httpHhy = createHttp();

  $httpHhy.interceptors.response.use(function (res) {
    if (res.levelType === '') {
      var errMsg = { message: '会员信息有误, 请检查商户信息是否配置正确' };
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    Object(__WEBPACK_IMPORTED_MODULE_6_components_api_utils__["t" /* setSessionStorageItem */])('userIdentity', {
      businessType: businessType,
      orgId: res.orgId,
      uid: res.uid,
      authId: res.authId,
      authUserName: res.authUserName, // 第三方用户名（公众号/支付宝partnerId）
      branchId: branchId,
      tableId: tableId,
      tableNo: tableNo,
      userId: res.id,
      showname: res.showname,
      mobile: res.mobile,
      levelType: res.levelType,
      userThirdValue: res.thirdChannelValue,
      appId: res.appId,
      isJC: isJC,
      menuType: menuType
    });
    return res;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
  });

  return $httpHhy.get(url);
}

/**
 * 获取当前会员信息
 * @param key 会员信息key值，null时返回会员所有信息
 * @returns Object|string|null
 */
function getUserIdentity() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_utils__["m" /* getSessionStorageItem */])('userIdentity');
  if (key === null) {
    return userIdentity;
  }
  return userIdentity ? userIdentity[key] : null;
}

/**
 * 更新当前会员信息
 * example:
 * updateUserIdentity('businessType', 'TS');
 * updateUserIdentity('', {businessType: 'TS'});
 * @param key 要更新的key，传空时表示更新多个字段
 * @param value 要更新的值，key为空时value应传对象
 */
function updateUserIdentity() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var value = arguments[1];

  var userIdentity = getUserIdentity(),
      updateSource = key === '' ? value : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, key, value);
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(userIdentity, updateSource);
  Object(__WEBPACK_IMPORTED_MODULE_6_components_api_utils__["t" /* setSessionStorageItem */])('userIdentity', userIdentity);
}

/**
 * 根据userId获取会员信息（从服务器查询）
 * @param userId
 * @return {Promise}
 */
function getUserInfoByUserId() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  var url = '/user/uid/' + userIdentity.uid + '/user_id/' + userId;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 获取会员可用卡券
 * @param userId
 * @return {Promise}
 */
function getUsercardList() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  var url = '/usercard/uid/' + userIdentity.uid + '/user_id/' + userId + '/branch_id/' + userIdentity.branchId + '?has_discount=1';
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 获取低分抵扣比例
 * @return {Promise}
 */
function getPointsConfig() {
  var uid = getUserIdentity('uid');
  var url = '/points-config/uid/' + uid;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 发送验证短信
 * @param mobile
 * @return {Promise}
 */
function sendSmsCode(mobile) {
  var userIdentity = getUserIdentity();
  var url = '/sms/send-sms-code';
  var $httpHhy = createHttp();
  return $httpHhy.post(url, {
    uid: userIdentity.uid,
    auth_id: userIdentity.authId,
    user_id: userIdentity.userId,
    mobile: mobile,
    operationChannel: 'SELF_ORDER',
    operationType: 'USER_UPDATE'
  });
}
/**
 * 更新会员信息
 * @param params Object {
 *    mobile: mobile,
 *    mobileCode: mobileCode,
 *    name: name
 *  }
 * @return {Promise}
 */
function updateUserInfo(params) {
  var _params$mobile = params.mobile,
      mobile = _params$mobile === undefined ? '' : _params$mobile,
      _params$mobileCode = params.mobileCode,
      mobileCode = _params$mobileCode === undefined ? '' : _params$mobileCode,
      _params$name = params.name,
      name = _params$name === undefined ? '' : _params$name,
      _params$sex = params.sex,
      sex = _params$sex === undefined ? '' : _params$sex,
      _params$birthday = params.birthday,
      birthday = _params$birthday === undefined ? '' : _params$birthday;

  var userIdentity = getUserIdentity();
  var url = '/user/auth_id/' + userIdentity.authId + '/user_id/' + userIdentity.userId;
  var $httpHhy = createHttp();
  $httpHhy.interceptors.response.use(function (res) {
    if (res.code === RESPONSE_CODE_SUCCESS) {
      updateUserIdentity('mobile', mobile);
      res.userId && updateUserIdentity('userId', res.userId);
    }
    return res;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpHhy.patch(url, {
    mobile: mobile,
    mobile_code: mobileCode,
    name: name,
    sex: sex,
    birthday: birthday,
    operationChannel: userIdentity.businessType,
    registerShopId: userIdentity.branchId
  });
}

/**
 * 添加配送地址
 * @param params
 * @return {Promise}
 */
function createUserShippingAddress(params) {
  var userIdentity = getUserIdentity();
  var url = '/user-shipping-address';
  var $httpHhy = createHttp();
  return $httpHhy.post(url, {
    uid: userIdentity.uid,
    user_id: userIdentity.userId,
    username: params.username,
    sex: params.sex,
    mobile: params.mobile,
    address: params.address,
    detail: params.detail,
    longitude: params.longitude,
    latitude: params.latitude,
    is_default: params.is_default
  });
}

/**
 * 修改配送地址
 * @param params
 * @return {Promise}
 */
function updateUserShippingAddress(params) {
  var userIdentity = getUserIdentity();
  var url = '/user-shipping-address/id/' + params.id;
  var $httpHhy = createHttp();
  return $httpHhy.put(url, {
    id: params.id,
    uid: userIdentity.uid,
    user_id: userIdentity.userId,
    username: params.username,
    sex: params.sex,
    mobile: params.mobile,
    address: params.address,
    detail: params.detail,
    longitude: params.longitude,
    latitude: params.latitude,
    is_default: params.is_default
  });
}

/**
 * 删除配送地址
 * @param id
 * @return {Promise}
 */
function deleteUserShippingAddress(id) {
  var userIdentity = getUserIdentity();
  var url = '/user-shipping-address/uid/' + userIdentity.uid + '/user_id/' + userIdentity.userId + '/id/' + id;
  var $httpHhy = createHttp();
  return $httpHhy.delete(url);
}

/**
 * 查询配送地址列表
 * @param isDefault
 * @return {Promise}
 */
function getUserShippingAddressList() {
  var isDefault = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var userIdentity = getUserIdentity();
  var url = '/user-shipping-address/uid/' + userIdentity.uid + '/user_id/' + userIdentity.userId + '/is_default/' + isDefault;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 根据第三方信息查询会员信息, 如扫码口碑码后
 * @param params
 * @return {Promise}
 */
function getUserByThirdChannelInfo(params) {
  var thirdChannel = params.thirdChannel,
      userThirdValue = params.userThirdValue,
      merchant = params.merchant,
      _params$shop = params.shop,
      shop = _params$shop === undefined ? 0 : _params$shop,
      businessType = params.businessType,
      _params$tableId2 = params.tableId,
      tableId = _params$tableId2 === undefined ? 0 : _params$tableId2,
      _params$tableNo2 = params.tableNo,
      tableNo = _params$tableNo2 === undefined ? '' : _params$tableNo2;

  var url = '/third-channel/' + thirdChannel + '/user/' + userThirdValue + '?businessType=' + businessType + '&merchant=' + merchant + '&shop=' + shop;
  var $httpHhy = createHttp();
  $httpHhy.interceptors.response.use(function (res) {
    if (res.levelType === '') {
      var errMsg = { message: '会员信息有误, 请检查商户信息是否配置正确' };
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    Object(__WEBPACK_IMPORTED_MODULE_6_components_api_utils__["t" /* setSessionStorageItem */])('userIdentity', {
      businessType: businessType,
      orgId: res.orgId,
      uid: res.uid,
      authId: res.authId,
      authUserName: res.authUserName, // 第三方用户名（公众号/支付宝partnerId）
      branchId: res.branchId,
      tableId: tableId,
      tableNo: tableNo,
      userId: res.id,
      showname: res.showname,
      mobile: res.mobile,
      levelType: res.levelType,
      userThirdValue: userThirdValue,
      appId: res.appId
    });
    return res;
  }, function (err) {
    if (err.response && err.response.status === 422) {
      var data = err.response.data,
          msg = data && data[0] && data[0]['message'] ? data[0]['message'] : '获取会员失败';
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject({ message: msg });
    }
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpHhy.get(url);
}

/**
 * 根据支付宝shop_id获取门店信息
 * @param {string} shopId
 * @return {Promise}
 */
function getBranchInfoByAliShopId(shopId) {
  var url = '/ali-info/get-branch/ali_shop_id/' + shopId,
      $http = createHttp();
  return $http.get(url);
}
/**
 * 查询会员权益描述
 * /user-right/description/{uid}
 * @return {Promise}
 */
function getUserRightDesc() {
  var uid = getUserIdentity().uid,
      url = '/user-right/description/' + uid,
      $http = createHttp();
  return $http.get(url);
}

/**
* 判断卡券是否可用
* 0. 是否可用于储值
* 1.消费金额大于等于卡券抵扣条件
* 2.卡券周几可用
* 3.卡券可用时段
* 4.卡券可用渠道
* 5.卡券可用菜品（折扣券不能用于套餐）
* @param card 卡券
* @param totalPrice 总金额
* @param foodList 订单菜 [{code（或goodsId）: '20007', foodType（或type）: 'SET_MEAL'}]
* @param payType 支付方式
* @return {boolean}
*/
function ifCardUsable(card, totalPrice, foodList, payType) {
  // 嘉和世纪套餐不支持优惠券0516
  if (card.uid === '106') {
    var hasSetMeal = foodList.filter(function (food) {
      var foodType = food.foodType || food.type;
      return foodType === 'SET_MEAL';
    }); // 交集
    if (hasSetMeal.length > 0) {
      return false;
    }
  }
  // 是否可用于储值
  if (payType === 'CARDPAY' && card.canPrepaidUse !== 'Y') {
    return false;
  }
  // 消费金额大于等于卡券抵扣条件
  if (totalPrice < card.leastCost) {
    return false;
  }
  // 卡券周几可用
  var currentDate = new Date(),
      currentWeek = currentDate.getDay(),
      cardWeek = card.useWeek.split(',');
  if (cardWeek.includes('' + currentWeek) === false) {
    return false;
  }
  // 券可用时段
  var currentDaySeconds = currentDate.getHours() * 60 * 60 + currentDate.getMinutes() * 60 + currentDate.getSeconds();
  if (currentDaySeconds < card.dayBeginTime || currentDaySeconds > card.dayEndTime) {
    return false;
  }
  // 卡券可用渠道
  var cardUseChannel = card.useChannel.split(','),
      businessType = getUserIdentity('businessType');
  if (cardUseChannel.includes(businessType) === false) {
    return false;
  }
  // 卡券可用菜品（折扣券不能用于套餐）
  var cardFoodsCode = card.foodNoList;
  var cardType = card.cardType;
  if (cardFoodsCode) {
    var intersection = foodList.filter(function (food) {
      var foodCode = food.code || food.goodsId;
      var foodType = food.foodType || food.type;
      return cardFoodsCode.includes(foodCode) && (cardType !== 'DISCOUNT' || foodType !== 'SET_MEAL');
    }); // 交集
    if (intersection.length === 0) {
      return false;
    }
  }
  return true;
}

/**
 * 查询会员权益等级信息
 * /uid/{uid}/levelType/{levelType}
 * @param levelType
 */
function getRightLevelDetail(levelType) {
  var uid = getUserIdentity('uid'),
      url = '/uid/' + uid + '/levelType/' + levelType,
      $http = createHttp();
  return $http.get(url);
}
/**
 * 查询会员权益等级信息-嘉和世纪门店开业配置
 * /uid/{uid}/branch/{branch}/levelType/{levelType}
 * @param levelType
 * @param branch
 */
function getRightLevelDetailByBranch(levelType, branch) {
  var uid = getUserIdentity('uid'),
      url = '/uid/' + uid + '/branch/' + branch + '/levelType/' + levelType,
      $http = createHttp();
  return $http.get(url);
}

/**
 * 储值规则列表
 * /uid/5320/shop/8325/pay-rules
 * @param type
 */
function getPayRules(type) {
  var _getUserIdentity = getUserIdentity(),
      uid = _getUserIdentity.uid,
      branchId = _getUserIdentity.branchId;

  var url = '/uid/' + uid + '/shop/' + branchId + '/pay-rules?payrule_type=' + type,
      $http = createHttp();
  return $http.get(url);
}

/**
 * 验证会员发送手机验证码（好友手机代付）
 * /check-user/send-code
 * @param mobile
 * @param code
 * @return {Promise}
 */
function checkUserSendSmsCode(mobile, code) {
  var url = '/check-user/send-code';

  var _getUserIdentity2 = getUserIdentity(),
      uid = _getUserIdentity2.uid;

  return createHttp().post(url, {
    uid: uid,
    mobile: mobile,
    code: code
  });
}

/**
 * 查询领券活动
 * @param params
 */
function getCouponActivity() {
  var _getUserIdentity3 = getUserIdentity(),
      uid = _getUserIdentity3.uid,
      branchId = _getUserIdentity3.branchId,
      businessType = _getUserIdentity3.businessType,
      userId = _getUserIdentity3.userId;

  var url = '/activity/card-first';
  return createHttp().post(url, {
    uid: uid,
    branchId: branchId,
    channel: businessType,
    userId: userId
  });
}
// 领取活动卡券 /activity/card-first/send
function takeActivityCards(activityArr) {
  var _getUserIdentity4 = getUserIdentity(),
      uid = _getUserIdentity4.uid,
      branchId = _getUserIdentity4.branchId,
      businessType = _getUserIdentity4.businessType,
      userId = _getUserIdentity4.userId;

  var url = '/activity/card-first/send';
  return createHttp().post(url, {
    uid: uid,
    branchId: branchId,
    channel: businessType,
    userId: userId,
    activityArr: activityArr
  });
}

/**
 * 提交投诉建议
 * @param {Object} payload
 * @return {Promise}
 */
function submitFeedback(payload) {
  return createHttp().post('/feedback', payload);
}

/**
 * 客户端错误日志上传
 * @param content
 */
function logging(content) {
  var identity = getUserIdentity() || {};
  var url = '/log/we-app';
  return createHttp().post(url, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ appType: 'selfOrderH5' }, identity, content));
}
/**
 * 查询会员今日卡券核销历史
 */
function userCardConsumeLogs() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  var url = '/user-card/consume-logs?uid=' + userIdentity.uid + '&user_id=' + userId;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

/**
 * 查询会员每餐（默认段时间内）参与每餐核销限制卡券的核销历史
 */
function timeSpanCardConsumeLog() {
  var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var userIdentity = getUserIdentity();
  userId = userId || userIdentity.userId;
  var url = '/user-card/time-span-card-consume-log?uid=' + userIdentity.uid + '&user_id=' + userId;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

function getWelcomeImage() {
  var uid = getUserIdentity().uid + '';
  var url = '/self-order/welcome-images/' + uid;
  var $httpHhy = createHttp();
  return $httpHhy.get(url);
}

function tableStatus() {
  var _getUserIdentity5 = getUserIdentity(),
      branchId = _getUserIdentity5.branchId,
      tableNo = _getUserIdentity5.tableNo;

  var url = '/table-status';
  return createHttp().post(url, {
    branchId: branchId,
    tableNo: tableNo
  });
}

/***/ }),

/***/ "W7QO":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.welcome-wrapper {\n  z-index: 9999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  overflow: hidden;\n  background: #111;\n}\n.welcome-wrapper .welcome-main,\n.welcome-wrapper .welcome-secondary {\n  position: absolute;\n  left: 0;\n  width: 100vw;\n  object-fit: cover;\n}\n.welcome-wrapper .welcome-main {\n  top: 0;\n  height: 100vh;\n}\n.welcome-wrapper .welcome-secondary {\n  bottom: 0;\n  height: auto;\n}\n.welcome-wrapper .hide-btn {\n  position: fixed;\n  right: 4vw;\n  top: 3vh;\n  min-width: 1.9rem;\n  padding: 0.16rem 0.3rem;\n  background: rgba(0,0,0,0.55);\n  color: #fff;\n  border: none;\n  border-radius: 999px;\n  font-size: 0.3rem;\n  box-shadow: 0 0.08rem 0.24rem rgba(0,0,0,0.2);\n}\n", ""]);

// exports


/***/ }),

/***/ "X623":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["o"] = isWechat;
/* harmony export (immutable) */ __webpack_exports__["n"] = isAlipay;
/* harmony export (immutable) */ __webpack_exports__["k"] = getClientType;
/* harmony export (immutable) */ __webpack_exports__["t"] = setSessionStorageItem;
/* harmony export (immutable) */ __webpack_exports__["m"] = getSessionStorageItem;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteSessionStorageItem;
/* unused harmony export filterJson */
/* unused harmony export getParameter */
/* unused harmony export arrayToJson */
/* harmony export (immutable) */ __webpack_exports__["s"] = setLocalStorageItem;
/* harmony export (immutable) */ __webpack_exports__["l"] = getLocalStorageItem;
/* harmony export (immutable) */ __webpack_exports__["i"] = formatTime;
/* unused harmony export wechatReady */
/* harmony export (immutable) */ __webpack_exports__["u"] = wechatCallpay;
/* unused harmony export wechatCloseWindow */
/* harmony export (immutable) */ __webpack_exports__["d"] = alipayReady;
/* harmony export (immutable) */ __webpack_exports__["c"] = alipayCallpay;
/* harmony export (immutable) */ __webpack_exports__["b"] = alipayCallScan;
/* unused harmony export aliCloseWindow */
/* harmony export (immutable) */ __webpack_exports__["e"] = appCloseWindow;
/* unused harmony export httpErrorMessage */
/* unused harmony export hasClass */
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony export (immutable) */ __webpack_exports__["r"] = removeClass;
/* unused harmony export toggleClass */
/* unused harmony export redirectPayUrl */
/* harmony export (immutable) */ __webpack_exports__["j"] = formatTimestamp;
/* unused harmony export findIndexUtils */
/* unused harmony export urlSearchToQueryObj */
/* unused harmony export logging */
/* harmony export (immutable) */ __webpack_exports__["g"] = arrayMapByColumn;
/* harmony export (immutable) */ __webpack_exports__["f"] = arrayGetColumn;
/* harmony export (immutable) */ __webpack_exports__["q"] = randomString;
/* harmony export (immutable) */ __webpack_exports__["p"] = mobileValidator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__ = __webpack_require__("34+y");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_mint_ui_lib_toast_style_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__ = __webpack_require__("X+yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__("pFYg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_api_interface_saas_order__ = __webpack_require__("mvSL");





/**
 * 工具方法
 * @author ytl
 */




/**
 * 判断是微信内置浏览器
 * @author ytl
 * @return {boolean}
 */
function isWechat() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.match(/MicroMessenger/i)) {
    return true;
  }
  return false;
}

/**
 * 判断是支付宝内置浏览器
 * @author ytl
 * @return {boolean}
 */
function isAlipay() {
  var userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.match(/Alipay/i)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 获取客户端类型
 * @author ytl
 * @return {*}
 */
function getClientType() {
  if (isWechat()) {
    return __WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__["b" /* CLIENT_WECHAT */];
  } else if (isAlipay()) {
    return __WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__["a" /* CLIENT_ALIPAY */];
  }
  return __WEBPACK_IMPORTED_MODULE_5_components_api_interface_hhy__["a" /* CLIENT_ALIPAY */];
}

/**
 * 存储sessionStorageItem
 * @author ytl
 * @param key string
 * @param value Object|Array|String
 */
function setSessionStorageItem(key, value) {
  var item = '';
  if (value instanceof Object) {
    item = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(value);
  } else {
    item = value;
  }
  window.sessionStorage.setItem(key, item);
}

/**
 * 获取sessionStorageItem
 * @author ytl
 * @param key string
 * @return {null}|string|Object
 */
function getSessionStorageItem(key) {
  var value = window.sessionStorage.getItem(key);
  if (!value) {
    return null;
  }
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
}
/**
 * deleteSessionStorageItem
 * @author ytl
 * @param key string
 * @return {null}|string|Object
 */
function deleteSessionStorageItem(key) {
  window.sessionStorage.removeItem(key);
}
// 搜索功能使用
// 过滤菜品名称
function filterJson(goodsList, searchTxt) {
  var filterFoods = [];
  var filterGoods = [];
  if (goodsList !== null && goodsList.length > 0) {
    goodsList.forEach(function (good) {
      if (good.foodList !== null && good.foodList.length > 0) {
        filterFoods = [];
        var temp = good.foodList.findIndex(function (item) {
          // 查找匹配的商品
          return item.name.indexOf(searchTxt) >= 0;
        });
        if (temp === -1) {
          // good.foodList.splice(temp, 1);
        } else {
          var currentFood = good.foodList[temp];
          filterFoods.push(currentFood);
        }
      }
      var newGood = '{"classId":' + good.classId + ',"className":' + '"' + good.className + '"' + ',"foodList":' + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(filterFoods) + ',"sort":' + good.sort + '}';
      filterGoods.push(newGood);
    });
  } else {
    return null;
  }
  return arrayToJson(filterGoods) === 'undefined' ? null : arrayToJson(filterGoods);
}
// 获取浏览器地址栏中的参数
function getParameter(name) {
  var value = location.search.match(new RegExp('[?&]' + name + '=([^&]*)(&?)', 'i'));
  return value ? decodeURIComponent(value[1]) : '';
}
function arrayToJson(o) {
  var r = [];
  if (typeof o === 'string') return o.replace(/([\'\"\\])/g, '$1').replace(/(\n)/g, '').replace(/(\r)/g, '\\r').replace(/(\t)/g, '\\t');
  if ((typeof o === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(o)) === 'object') {
    if (!o.sort) {
      for (var i in o) {
        r.push(i + ':' + arrayToJson(o[i]));
      }
      if (!!document.all && !/^\n?function\s*toString\(\)\s*\{\n?\s*\[native code\]\n?\s*\}\n?\s*$/.test(o.toString)) {
        r.push('toString:' + o.toString.toString());
      }
      r = '{' + r.join() + '}';
    } else {
      for (var _i = 0; _i < o.length; _i++) {
        r.push(arrayToJson(o[_i]));
      }
      r = '[' + r.join() + ']';
    }
    return r;
  }
  return o.toString();
}

/**
 * 存储localStorageItem
 * @author ytl
 * @param key string
 * @param value Object|Array|String
 * @param dueTime int 本地存储的期限（毫秒），0表示永久有效
 */
function setLocalStorageItem(key, value) {
  var dueTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  var expireTime = 0;
  if (dueTime > 0) {
    expireTime = new Date().getTime() + dueTime;
  }

  var item = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ data: value, expireTime: expireTime });
  window.localStorage.setItem(key, item);
}

/**
 * 获取sessionStorageItem
 * @author ytl
 * @param key string
 * @return {null}|string|Object
 */
function getLocalStorageItem(key) {
  var value = window.localStorage.getItem(key);
  if (!value) {
    return null;
  }
  value = JSON.parse(value);
  var curTime = new Date().getTime();
  if (value.expireTime && value.expireTime > 0 && value.expireTime < curTime) {
    window.localStorage.removeItem(key);
    return null;
  }
  return value.data;
}

/**
 * 格式化秒数
 * @author ytl
 * @param leftTime 开始的秒数
 * @return {Object}
 */
function formatTime(leftTime) {
  var dd = parseInt(leftTime / 60 / 60 / 24, 10); // 剩余天数
  var hh = parseInt(leftTime / 60 / 60 % 24, 10); // 剩余小时数
  var mm = parseInt(leftTime / 60 % 60, 10); // 剩余分钟数
  var ss = parseInt(leftTime % 60, 10); // 剩余秒数
  dd = checkTime(dd);
  hh = checkTime(hh);
  mm = checkTime(mm);
  ss = checkTime(ss);
  return {
    dd: dd,
    mm: mm,
    hh: hh,
    ss: ss
  };
}

/**
 * 不满两位前面补零
 * @param time 时间值
 * @return {*}
 */
function checkTime(time) {
  if (time < 10) {
    time = '0' + time;
  }
  return time;
}

// WeixinJSBridge
function wechatReady(callBack) {
  if ((typeof WeixinJSBridge === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(WeixinJSBridge)) === undefined) {
    if (document.addEventListener) {
      document.addEventListener('WeixinJSBridgeReady', callBack, false);
    } else if (document.attachEvent) {
      document.attachEvent('WeixinJSBridgeReady', callBack);
      document.attachEvent('onWeixinJSBridgeReady', callBack);
    }
  } else {
    callBack && callBack();
  }
}

/**
 * 调用微信JS api 收银台
 * @param {Object} payInfo
 * @param {Object} vm vue实例
 * @param {Function} callBack
 */
function wechatCallpay(payInfo, vm, callBack) {
  wechatReady(function () {
    WeixinJSBridge.invoke('getBrandWCPayRequest', payInfo, function (res) {
      // alert(JSON.stringify(payInfo));
      // alert(res.err_msg);
      // alert(res.err_code + res.err_desc + res.err_msg);
      if (res.err_msg === 'get_brand_wcpay_request:ok') {
        payInfo.out_trade_no && Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_saas_order__["s" /* orderPayNotify */])(payInfo.out_trade_no);
        callBack && callBack(vm);
      }
      if (res.err_msg === 'get_brand_wcpay_request:cancel') {
        __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()('支付取消了');
      }
      if (res.err_msg === 'get_brand_wcpay_request:fail') {
        vm.$loggerInstance && vm.$loggerInstance.error(new Error('微信支付失败：' + __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(res)));
        __WEBPACK_IMPORTED_MODULE_2_mint_ui_lib_toast___default()('支付失败了');
      }
    });
  });
}

/**
 * 微信内关闭浏览器窗口
 */
function wechatCloseWindow() {
  wechatReady(function () {
    WeixinJSBridge.invoke('closeWindow', {}, function (e) {});
  });
}

/**
 * 由于js的载入是异步的，所以可以通过该方法，当AlipayJSBridgeReady事件发生后，再执行callback方法
 * @param {Function} callback
 */
function alipayReady(callback) {
  if (window.AlipayJSBridge) {
    callback && callback();
  } else {
    document.addEventListener('AlipayJSBridgeReady', callback, false);
  }
}

/**
 * 阿里支付入口 唤起alipay js api 收银台
 * @param {Object} payInfo
 * @param {Object} vm vue实例
 * @param {Function} afterJsPay
 */
function alipayCallpay(payInfo, vm, afterJsPay) {
  alipayReady(function () {
    AlipayJSBridge.call('tradePay', {
      tradeNO: payInfo.trade_no
    }, function (data) {
      if (parseInt(data.resultCode) === 9000) {
        afterJsPay && afterJsPay(vm);
      } else {
        alert('支付失败了');
      }
    });
  });
}

/**
 * 支付宝扫一扫, 并直接让支付宝解码
 */
function alipayCallScan() {
  alipayReady(function () {
    AlipayJSBridge.call('scan', {
      type: 'qr',
      actionType: 'scanAndRoute'
    }, function (result) {
      console.log('支付宝扫一扫', result);
    });
  });
}

/**
 * 支付宝内关闭浏览器窗口
 */
function aliCloseWindow() {
  alipayReady(function () {
    AlipayJSBridge.call('popWindow');
  });
}

/**
 * 微信或支付宝内关闭浏览器窗口
 */
function appCloseWindow() {
  if (isWechat()) {
    wechatCloseWindow();
  } else if (isAlipay()) {
    aliCloseWindow();
  }
}

/**
 * http请求错误码描述
 * @param {Object} err 请求错误对象
 * @return {Object} err
 */
function httpErrorMessage(err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 400:
        err.message = '请求错误';
        break;
      case 401:
        err.message = '未授权，请登录';
        break;
      case 403:
        err.message = '拒绝访问';
        break;
      case 404:
        err.message = '';
        break;
      case 408:
        err.message = '请求超时';
        break;
      case 500:
        err.message = '服务器内部错误';
        break;
      case 501:
        err.message = '服务未实现';
        break;
      case 502:
        err.message = '网关错误';
        break;
      case 503:
        err.message = '服务不可用';
        break;

      case 504:
        err.message = '网关超时';
        break;
      case 505:
        err.message = 'HTTP版本不受支持';
        break;
      default:
        err.message = '';
    }
  }

  return err;
}

/**
 * 检查某个元素是否有某个class
 * @param ele
 * @param className
 * @return {Boolean}
 */
function hasClass(ele, className) {
  return ele && ele.className && ele.className.match(new RegExp('(\\s|^)' + className + '(\\s|$)'));
}

/**
 * 给元素添加class
 * @param ele
 * @param className
 */
function addClass(ele, className) {
  if (!hasClass(ele, className)) {
    ele.className += ' ' + className;
  };
}

/**
 * 元素移除class
 * @param ele
 * @param className
 */
function removeClass(ele, className) {
  if (hasClass(ele, className)) {
    var reg = new RegExp('(\\s|^)' + className + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/**
 * 元素toggle class
 * @param ele
 * @param className
 */
function toggleClass(ele, className) {
  if (hasClass(ele, className)) {
    removeClass(ele, className);
  } else {
    addClass(ele, className);
  }
}

/**
 *
 * @param orderId
 */
function redirectPayUrl(orderId) {
  var _window$location = window.location,
      href = _window$location.href,
      protocol = _window$location.protocol,
      host = _window$location.host,
      search = _window$location.search,
      hash = _window$location.hash,
      pathname = _window$location.pathname;
  // search = search || '?';

  var newHref = protocol + '//' + host + pathname + search + '#/pay/' + orderId;
  window.location.href = newHref;
}
/**
 *  格式化时间戳，转换为'yyyy-MM-dd hh:mm:ss'
 * @param timestamp
 */
function formatTimestamp(timestamp) {
  var date = '';
  if (timestamp) {
    date = new Date(parseInt(timestamp) * 1000);
  } else {
    date = new Date();
  }
  var Y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate(),
      H = date.getHours(),
      i = date.getMinutes(),
      s = date.getSeconds();
  if (m < 10) {
    m = '0' + m;
  }
  if (d < 10) {
    d = '0' + d;
  }
  if (H < 10) {
    H = '0' + H;
  }
  if (i < 10) {
    i = '0' + i;
  }
  if (s < 10) {
    s = '0' + s;
  }
  var tt = Y + '-' + m + '-' + d + ' ' + H + ':' + i;
  return tt;
}

/**
 * ES6 Array.findIndex替代函数
 * 解决支付宝和微信浏览器内的兼容性问题
 * @param arr
 * @param callback
 * @return {number}
 */
function findIndexUtils(arr, callback) {
  var index = -1;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var item = _step.value;

      if (callback(item)) {
        index++;
        break;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return index;
}

/**
 * url中的search字符串转对象
 * @return {Object}
 */
function urlSearchToQueryObj() {
  var search = window.location.search.substring(1),
      arr = search.split('&'),
      query = {};
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var param = _step2.value;

      var index = param.indexOf('=');
      if (index > 0) {
        var name = param.substring(0, index),
            value = param.substring(index + 1);
        query[name] = value;
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return query;
}

/**
 * 日记记录
 * @param key
 * @param str
 */
function logging(key, str) {
  var logStr = window.localStorage.getItem(key) ? window.localStorage.getItem(key) : '';
  window.localStorage.setItem(key, logStr + '-----' + str);
}

/**
 * 数组按某个或某几个列值为索引转换为对象
 * @param {Array} arr 原始数组
 * @param {String | Array} column 作为索引的列名,column为数组时，各列值以'-'链接后作为索引
 */
function arrayMapByColumn(arr, column) {
  if (typeof column !== 'string' && column instanceof Array === false) {
    return arr;
  }
  var result = {};
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var item = _step3.value;

      var key = '';
      if (typeof column === 'string') {
        key = item[column];
      } else {
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(column), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var col = _step4.value;

            key += item[col] + '-';
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        key = key.substr(0, key.length - 1);
      }
      result[key] = item;
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return result;
}

/**
 * 取数组的某一列或某几列组成一个新的数组
 * @param {Array} arr 原始数组
 * @param {String | Array} column 作为索引的列名,column为数组时，各列值以'-'链接后作为新的值
 * eg:
 * let arr = [{id: 1, name: 'a'}, {id: 2, name: 'b'}]
 * arrayGetColumn(arr, id)  // [1, 2]
 *
 */
function arrayGetColumn(arr, column) {
  if (typeof column !== 'string' && column instanceof Array === false) {
    return arr;
  }
  var result = [];
  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(arr), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var item = _step5.value;

      var value = '';
      if (typeof column === 'string') {
        value = item[column];
      } else {
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(column), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var col = _step6.value;

            value += item[col] + '-';
          }
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }
      }
      result.push(value);
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }

  return result;
}

/**
 * 生成指定长度的随机字符串
 * @param len
 * @return {string}
 */
function randomString(len) {
  len = len || 32;
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
      maxPos = chars.length,
      str = '';
  for (var i = 0; i < len; i++) {
    str += chars.charAt(Math.floor(Math.random() * (maxPos + 1)));
  }
  return str;
}

/**
 * 验证手机号码
 * @param mobile
 * @return {boolean}
 */
function mobileValidator(mobile) {
  var reg = /^1\d{10}$/;
  if (mobile && !reg.test(mobile)) {
    return false;
  }
  return true;
}

/***/ }),

/***/ "bbc5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__("PJh5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);


/**
 * @author wangd
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('time', function (value, formatString) {
  return __WEBPACK_IMPORTED_MODULE_1_moment___default()(value).format(formatString);
});

/**
 * @author wangd
 * @param timestamp 时间戳
 * @return yyyy-MM-dd hh:mm:ss
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('formatTime', function (timestamp) {
  var date = '';
  if (timestamp) {
    date = new Date(parseInt(timestamp) * 1000);
  } else {
    date = new Date();
  }
  var Y = date.getFullYear(),
      m = date.getMonth() + 1,
      d = date.getDate(),
      H = date.getHours(),
      i = date.getMinutes(),
      s = date.getSeconds();
  if (m < 10) {
    m = '0' + m;
  }
  if (d < 10) {
    d = '0' + d;
  }
  if (H < 10) {
    H = '0' + H;
  }
  if (i < 10) {
    i = '0' + i;
  }
  if (s < 10) {
    s = '0' + s;
  }
  var tt = Y + '-' + m + '-' + d + ' ' + H + ':' + i;
  return tt;
});

/**
 * 格式化金额
 * @param {number | string} value
 * @param {int} fixedDigits 保留小数的位数, 若不传如果金额为整数，则直接显示￥金额，如果为小数，则显示最多两位小数的人民币金额
 * @return 例：￥12 || ￥12.26
 */
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('money', function (value, fixedDigits) {
  value = isNaN(value) ? 0 : value;
  if (/^\d+$/.test(fixedDigits)) {
    return '￥ ' + parseFloat(value).toFixed(fixedDigits);
  }
  var reg = /\./;
  if (reg.test(value)) {
    var fixedNum = value.toString().split('.')[1]; //
    if (fixedNum === '00') {
      return '￥ ' + value.toString().split('.')[0];
    } else {
      if (fixedNum.length > 1) {
        if (fixedNum[fixedNum.length - 1] === '0') {
          return '￥ ' + parseFloat(value).toFixed(1);
        } else {
          return '￥ ' + parseFloat(value).toFixed(2);
        }
      } else {
        return '￥ ' + parseFloat(value).toFixed(1);
      }
    }
  } else {
    return '￥ ' + value;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.filter('money1', function (value) {
  var reg = /\./;
  if (!value) {
    return '-￥0';
  }
  if (reg.test(value)) {
    var fixedNum = value.toString().split('.')[1]; //
    if (fixedNum === '00') {
      return '-￥' + value.toString().split('.')[0];
    } else {
      return '-￥' + parseFloat(value).toFixed(2);
    }
  } else {
    return '-￥' + value;
  }
});

/***/ }),

/***/ "by/L":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_src_components_api_utils__ = __webpack_require__("X623");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/**
 * 领券活动的单个卡券
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // 使用其它组件
  components: {},
  props: {
    card: {
      type: Object,
      default: {}
    }
  },
  // 属性
  data: function data() {
    return {};
  },

  // 计算属性
  computed: {
    // 有效期
    effectDate: function effectDate() {
      var _card = this.card,
          type = _card.type,
          begin_timestamp = _card.begin_timestamp,
          end_timestamp = _card.end_timestamp,
          beginTerm = _card.fixed_begin_term,
          fixedTerm = _card.fixed_term;

      if (type === 'DATE_TYPE_FIX_TIME_RANGE') {
        // 固定日期
        var beginDate = Object(__WEBPACK_IMPORTED_MODULE_0_src_components_api_utils__["j" /* formatTimestamp */])(begin_timestamp);
        var endDate = Object(__WEBPACK_IMPORTED_MODULE_0_src_components_api_utils__["j" /* formatTimestamp */])(end_timestamp);
        return beginDate.substring(0, 10) + ' 至 ' + endDate.substring(0, 10);
      }
      if (type === 'DATE_TYPE_FIX_TERM') {
        beginTerm = beginTerm > 0 ? beginTerm : '当';
        return '\u9886\u5238\u540E' + beginTerm + '\u5929\u751F\u6548\uFF0C' + fixedTerm + '\u5929\u6709\u6548';
      }
      return '';
    },
    reduceCost: function reduceCost() {
      var amount = (this.card.reduce_cost || 0) - 0;
      return amount.toFixed(2);
    }
  },
  watch: {},
  // 生命周期函数
  created: function created() {},
  mounted: function mounted() {},

  methods: {}
});

/***/ }),

/***/ "cMrd":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("W7QO");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("65bf8c4d", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fdcedba4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Welcome.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-fdcedba4\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Welcome.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "ccwP":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("CcCL");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("30c5e8dd", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue", function() {
     var newContent = require("!!../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-7ba5bd90\",\"scoped\":false,\"hasInlineConfig\":false}!../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./App.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "d73z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TakeCardItem_vue__ = __webpack_require__("by/L");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8308e664_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TakeCardItem_vue__ = __webpack_require__("PeiJ");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("wp25")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TakeCardItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8308e664_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TakeCardItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/common/TakeCardItem.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8308e664", Component.options)
  } else {
    hotAPI.reload("data-v-8308e664", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "d7ik":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_api_interface_hhy__ = __webpack_require__("UZDt");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/**
 * 应用启动欢迎页
 * 应用进入时显示，5S后自动隐藏，用户点击【跳过】时隐藏
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // 使用其它组件
  components: {},
  // 属性
  data: function data() {
    return {
      seconds: 4,
      timerId: null,
      identity: Object(__WEBPACK_IMPORTED_MODULE_2_src_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      images: []
    };
  },

  // 计算属性
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(['welcomeImgVisible'])),
  watch: {},
  // 生命周期函数
  created: function created() {
    var _this = this;

    Object(__WEBPACK_IMPORTED_MODULE_2_src_components_api_interface_hhy__["t" /* getWelcomeImage */])().then(function (res) {
      _this.images = res;
    }).catch(function () {
      console.log('welcome-images-error');
    });
    this.timerId = setInterval(function () {
      _this.seconds--;
      if (_this.seconds <= 0) {
        _this.setWelcomeImgVisible(false);
        clearInterval(_this.timerId);
      }
    }, 600);
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['setWelcomeImgVisible']), {
    hideImg: function hideImg() {
      this.setWelcomeImgVisible(false);
      clearInterval(this.timerId);
    }
  })
});

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eU0C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "icon",
      attrs: {
        t: "1583806459458",
        viewBox: "0 0 1053 1024",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        "p-id": "2392",
        width: "23",
        height: "23"
      }
    },
    [
      _c("path", {
        attrs: {
          fill: "#fb4e44",
          d:
            "M488.218 225.024v231.388H13.517V270.664c0-29.236 23.117-52.619 52.08-52.619h216.336c-58.087-12.298-101.689-37.437-103.27-83.814-1.629-54.702 59.356-143.048 148.459-122.865 91.955 20.926 156.196 92.877 205.384 154.486C582.17 102.958 652.524 22.016 748.529 9.232 828.733-0.989 895.032 79.958 886.502 133.37c-7.321 46.807-51.66 72.315-108.272 84.618h213.596c28.964 0 52.086 23.43 52.086 52.618V456.3H569.16l-0.999-233.836M336.916 59.832c-44.39-17.735-70.405 1.28-89.103 32.482-10.163 17.628-21.12 41.113-4.895 58.316 42.706 44.411 159.826 41.114 238.403 32.855-37.023-46.755-82.575-99-144.405-123.653zM822.2 150.313c30.495-39.465-29.281-121.692-93.527-91.28C667.218 88.219 622.88 135.88 584.7 182.744c32.911 2.929 66.242 3.676 99.261 2.074 40.238-1.705 114.704-4.526 138.24-34.51z m-330.716 861.645H104.571c-26.01 0-47.186-21.3-47.186-48.036V493.855h434.15v518.103h-0.05z m508.508-48.092c0 26.731-21.12 48.035-47.186 48.035H565.95V493.798h434.043v470.068z",
          "p-id": "2393"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4ddbeeb5", esExports)
  }
}

/***/ }),

/***/ "f/ky":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("BO1k");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_icons_Gift__ = __webpack_require__("/aV+");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_common_TakeCardItem__ = __webpack_require__("d73z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_src_components_api_interface_hhy__ = __webpack_require__("UZDt");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/**
 * 领券
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // 使用其它组件
  components: {
    giftIcon: __WEBPACK_IMPORTED_MODULE_3_src_components_icons_Gift__["a" /* default */],
    takeCardItem: __WEBPACK_IMPORTED_MODULE_4_src_components_common_TakeCardItem__["a" /* default */]
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  // 属性
  data: function data() {
    return {
      submitting: false
    };
  },

  // 计算属性
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["e" /* mapState */])(['takeCardsArr'])),
  watch: {},
  // 生命周期函数
  created: function created() {},
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["d" /* mapMutations */])(['setTakeCardsModalVisible', 'addTakeCardsBranchIds']), {
    // 领券卡券
    takeCards: function takeCards() {
      var _this = this;

      if (this.submitting) {
        return false;
      }
      this.submitting = true;
      var activityArr = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.takeCardsArr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var activity = _step.value;

          var cardIdArr = [];
          var _iteratorNormalCompletion2 = true;
          var _didIteratorError2 = false;
          var _iteratorError2 = undefined;

          try {
            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(activity.cards), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
              var card = _step2.value;

              cardIdArr.push({ id: card.id, send_count: card.num });
            }
          } catch (err) {
            _didIteratorError2 = true;
            _iteratorError2 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
              }
            } finally {
              if (_didIteratorError2) {
                throw _iteratorError2;
              }
            }
          }

          activityArr.push({
            activityId: activity.activity_id,
            cardsArr: cardIdArr
          });
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      Object(__WEBPACK_IMPORTED_MODULE_5_src_components_api_interface_hhy__["z" /* takeActivityCards */])(activityArr).then(function (res) {
        _this.submitting = false;
        _this.$toast('领取成功');
        _this.setTakeCardsModalVisible(false);
        _this.addTakeCardsBranchIds(Object(__WEBPACK_IMPORTED_MODULE_5_src_components_api_interface_hhy__["p" /* getUserIdentity */])('branchId'));
      }).catch(function () {
        _this.submitting = false;
        _this.$toast('领取失败');
      });
    }
  })
});

/***/ }),

/***/ "hExl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TakeCardsModal_vue__ = __webpack_require__("f/ky");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14792755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TakeCardsModal_vue__ = __webpack_require__("2GNu");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("SEB5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TakeCardsModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14792755_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TakeCardsModal_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/common/TakeCardsModal.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14792755", Component.options)
  } else {
    hotAPI.reload("data-v-14792755", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "m+LJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ROUTES_WITHOUT_IDENTITY; });
// 公共配置文件

// 无需用户身份验证的路由
var ROUTES_WITHOUT_IDENTITY = ['error', 'error2', 'payResult', 'aliScan', 'aliError', 'aliScanOrderDetail'];

/***/ }),

/***/ "mvSL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ORDER_PAY_SUCCESS; });
/* unused harmony export ORDER_PAY_WAITING */
/* unused harmony export ORDER_PAY_FAIL */
/* unused harmony export ORDER_PAY_CHECKING */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ORDER_PAY_TIME_OUT; });
/* unused harmony export ORDER_STATUS_WAIT_RECEIVE_ORDER */
/* unused harmony export ORDER_STATUS_BRANCH_RECEIVED_ORDER */
/* unused harmony export ORDER_STATUS_BRANCH_CANCELED_ORDER */
/* unused harmony export ORDER_STATUS_ORDER_FINISHED */
/* unused harmony export ORDER_STATUS_ORDER_MAKEING */
/* unused harmony export ORDER_STATUS_ORDER_MAKING */
/* unused harmony export DISCOUNT_SCORE */
/* unused harmony export DISCOUNT_COUPON */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DISCOUNT_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PAY_TYPE_ALIPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return PAY_TYPE_WECHAT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return PAY_TYPE_CARDPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PAY_TYPE_ANOTHER_MOBILE; });
/* unused harmony export PAY_TYPE_ANOTHER_SHARE */
/* unused harmony export PAY_TYPE_MAP */
/* unused harmony export createHttp */
/* unused harmony export createHttpTest */
/* harmony export (immutable) */ __webpack_exports__["u"] = orderStatus;
/* harmony export (immutable) */ __webpack_exports__["q"] = orderDescription;
/* harmony export (immutable) */ __webpack_exports__["t"] = orderPayType;
/* harmony export (immutable) */ __webpack_exports__["o"] = orderCanPay;
/* harmony export (immutable) */ __webpack_exports__["n"] = orderCanCopy;
/* harmony export (immutable) */ __webpack_exports__["p"] = orderCreate;
/* harmony export (immutable) */ __webpack_exports__["j"] = getOrderDetail;
/* harmony export (immutable) */ __webpack_exports__["k"] = getOrderList;
/* harmony export (immutable) */ __webpack_exports__["r"] = orderPay;
/* harmony export (immutable) */ __webpack_exports__["s"] = orderPayNotify;
/* harmony export (immutable) */ __webpack_exports__["l"] = getTableFinishedOrder;
/* harmony export (immutable) */ __webpack_exports__["i"] = checkHasBill;
/* harmony export (immutable) */ __webpack_exports__["h"] = afterPay;
/* harmony export (immutable) */ __webpack_exports__["m"] = getUserPreOrderSummary;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__("woOf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__ = __webpack_require__("UZDt");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_api_interface_saas__ = __webpack_require__("qkUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__interface_saas__ = __webpack_require__("qkUO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__ = __webpack_require__("G4VM");




var _DISCOUNT_MAP, _PAY_TYPE_MAP;









/**
 * 订单支付状态 SUCCESS,WAITING,FAIL，CHECKING
 * WAITING|FAIL且剩余时间>0,可以进行支付操作
 */
var ORDER_PAY_SUCCESS = 'SUCCESS';
var ORDER_PAY_WAITING = 'WAITING';
var ORDER_PAY_FAIL = 'FAIL';
var ORDER_PAY_CHECKING = 'CHECKING';
var ORDER_PAY_TIME_OUT = 'TIME_OUT';

/*
 * 未接单（交易创建等待商家接单）WAIT_RECEIVE_ORDER
 * 商家已经接单BRANCH_RECEIVED_ORDER
 * 商家取消订单BRANCH_CANCELED_ORDER
 * 订单完成ORDER_FINISHED
 * 订单制作中ORDER_MAKEING,
 * PAY_TIMEOUT:因为支付超时而取消
 */
var ORDER_STATUS_WAIT_RECEIVE_ORDER = 'WAIT_RECEIVE_ORDER';
var ORDER_STATUS_BRANCH_RECEIVED_ORDER = 'BRANCH_RECEIVED_ORDER';
var ORDER_STATUS_BRANCH_CANCELED_ORDER = 'BRANCH_CANCELED_ORDER';
var ORDER_STATUS_ORDER_FINISHED = 'ORDER_FINISHED';
var ORDER_STATUS_ORDER_MAKEING = 'ORDER_MAKEING';
var ORDER_STATUS_ORDER_MAKING = 'ORDER_MAKEING';

// 优惠 SCORE积分 COUPON卡券
var DISCOUNT_SCORE = 'SCORE';
var DISCOUNT_COUPON = 'COUPON';
var DISCOUNT_MAP = (_DISCOUNT_MAP = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_DISCOUNT_MAP, DISCOUNT_SCORE, '积分'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_DISCOUNT_MAP, DISCOUNT_COUPON, '抵用券'), _DISCOUNT_MAP);

// 支付方式：ALIPAY支付宝，WECHAT 微信，CARDPAY好会员支付
var PAY_TYPE_ALIPAY = 'ALIPAY';
var PAY_TYPE_WECHAT = 'WECHAT';
var PAY_TYPE_CARDPAY = 'CARDPAY';
var PAY_TYPE_ANOTHER_MOBILE = 'ANOTHER_MOBILE'; // 好友手机代付
var PAY_TYPE_ANOTHER_SHARE = 'ANOTHER_SHARE'; // 好友分享代付
var PAY_TYPE_MAP = (_PAY_TYPE_MAP = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_MAP, PAY_TYPE_ALIPAY, '支付宝支付'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_MAP, PAY_TYPE_WECHAT, '微信支付'), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_PAY_TYPE_MAP, PAY_TYPE_CARDPAY, '会员优惠买单'), _PAY_TYPE_MAP);

/**
 * 创建axios实例
 * @return {axios}
 */
function createHttp() {
  var $httpSaas = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_4_src_config_params_local__["f" /* INTERACE_SAAS_ORDER_BASE_URL */],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });
  // 添加一个响应拦截器
  $httpSaas.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["w" /* logging */])({ request: res.request, responseData: res.data });
      var errMsg = { message: res.data.msg || '' };
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, function (err) {
    var responseData = err.response ? err.response.data : null;
    Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["w" /* logging */])({
      request: err.request,
      responseData: responseData,
      err: responseData ? null : err
    });
    var errorInfo = err.response ? err.response.data : err;
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errorInfo);
  });
  return $httpSaas;
}

/**
 * 创建axios实例--测试
 * 测试使用
 * return createHttpTest.get('static/test/xxx.json');
 * @return {axios}
 */
function createHttpTest() {
  var $httpSaas = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create();
  // 添加一个响应拦截器
  $httpSaas.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["w" /* logging */])({ request: res.config, responseData: res.data });
      var errMsg = { response: { data: { message: res.data.msg ? res.data.msg : '' } } };
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return res.data.body ? res.data.body : res.data;
  }, function (err) {
    var responseData = err.response ? err.response.data : null;
    Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["w" /* logging */])({
      request: err.config,
      responseData: responseData,
      err: responseData ? null : err
    });
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpSaas;
}

/**
 * 订单状态
 * @param {String} payStatus
 * @param {String} status
 */
function orderStatus(payStatus, status) {
  if (status === __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].state.appConst.ORDER_STATUS_PRE_ORDER) {
    return '待下单';
  }
  switch (payStatus) {
    case ORDER_PAY_WAITING:
      return '待支付';
    case ORDER_PAY_FAIL:
      return '支付失败';
    case ORDER_PAY_CHECKING:
      return '支付确认中';
    case ORDER_PAY_TIME_OUT:
      return '已取消';
    case ORDER_PAY_SUCCESS:
      return '已完成';
  }
  return ' ';
}
/**
 * 订单描述
 * @param {String} payStatus
 * @param {String} status
 */
function orderDescription(payStatus, status) {
  switch (payStatus) {
    case ORDER_PAY_WAITING:
    case ORDER_PAY_FAIL:
      return '订单未支付，超时将自动取消';
    case ORDER_PAY_CHECKING:
      return '支付处理中，请稍后确认';
    case ORDER_PAY_TIME_OUT:
      return '超时未支付';
    case ORDER_PAY_SUCCESS:
      return '感谢您对本店的支持，欢迎再次光临';
  }
  return ' ';
}

/**
 * 订单支付方式
 * @param {String} payStatus
 * @param {String} payType
 */
function orderPayType(payStatus, payType) {
  if (payStatus !== ORDER_PAY_SUCCESS) {
    return '尚未支付';
  }
  return PAY_TYPE_MAP[payType] ? PAY_TYPE_MAP[payType] : '';
}

/**
 * 判断订单是否可支付
 * @param order
 * @return {boolean}
 */
function orderCanPay(order) {
  var checkMode = order.checkMode;
  return order.preorder !== __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].state.appConst.PRE_ORDER_Y && (order.timeLeft > 0 || checkMode === __WEBPACK_IMPORTED_MODULE_8__interface_saas__["j" /* TS_PAY_TYPE_AFTER */]) && (order.payStatus === ORDER_PAY_WAITING || order.payStatus === ORDER_PAY_FAIL);
}

/**
 * 判断订单是否可【再来一单】
 * @param order
 * @return {boolean}
 */
function orderCanCopy(order) {
  return order.orderType !== __WEBPACK_IMPORTED_MODULE_7_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && order.payStatus === ORDER_PAY_SUCCESS;
}

/**
 * 预点餐：POST /v1/order/pre/submit
 * 下单：/order
 * @param params
 */
function orderCreate(params) {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      isPreOrder = userIdentity.businessType === __WEBPACK_IMPORTED_MODULE_7_components_api_interface_saas__["d" /* BUSINESS_TYPE_TS */] && !userIdentity.tableId && !userIdentity.tableNo,
      url = isPreOrder ? '/order/pre/submit' : '/order';
  var _params$id = params.id,
      id = _params$id === undefined ? 0 : _params$id,
      mobile = params.mobile,
      _params$persons = params.persons,
      persons = _params$persons === undefined ? 1 : _params$persons,
      _params$note = params.note,
      note = _params$note === undefined ? '' : _params$note,
      _params$arriveTime = params.arriveTime,
      arriveTime = _params$arriveTime === undefined ? 0 : _params$arriveTime,
      _params$personNum = params.personNum,
      personNum = _params$personNum === undefined ? 0 : _params$personNum,
      _params$receiver = params.receiver,
      receiver = _params$receiver === undefined ? '' : _params$receiver,
      _params$deliverAddres = params.deliverAddress,
      deliverAddress = _params$deliverAddres === undefined ? '' : _params$deliverAddres,
      _params$foodList = params.foodList,
      foodList = _params$foodList === undefined ? [] : _params$foodList,
      _params$needPayCost = params.needPayCost,
      needPayCost = _params$needPayCost === undefined ? 0 : _params$needPayCost,
      _params$token = params.token,
      token = _params$token === undefined ? '' : _params$token;
  var branchId = userIdentity.branchId,
      businessType = userIdentity.businessType,
      userId = userIdentity.userId,
      levelType = userIdentity.levelType,
      _userIdentity$tableId = userIdentity.tableId,
      tableId = _userIdentity$tableId === undefined ? 0 : _userIdentity$tableId,
      _userIdentity$tableNo = userIdentity.tableNo,
      tableNo = _userIdentity$tableNo === undefined ? '' : _userIdentity$tableNo,
      orgId = userIdentity.orgId,
      uid = userIdentity.uid;

  var newParams = {
    id: id,
    branchId: branchId,
    orderChannel: Object(__WEBPACK_IMPORTED_MODULE_5_components_api_utils__["k" /* getClientType */])(),
    mobile: mobile,
    orderType: businessType,
    persons: persons,
    orderUser: userId,
    note: note,
    tableId: tableId,
    tableNo: tableNo,
    arriveTime: arriveTime,
    personNum: personNum,
    receiver: receiver,
    deliverAddress: deliverAddress,
    customerLevel: levelType,
    foodList: foodList,
    orgId: orgId,
    uid: uid,
    needPayCost: needPayCost,
    token: token
  };
  var $httpSaas = createHttp();
  return $httpSaas.post(url, newParams);
}

//
/**
 * GET /v1/branch/{branchId}/order/{orderId}
 * 查询订单详情
 * @param orderId
 * @param branchId
 * @return {Promise}
 */
function getOrderDetail(orderId) {
  var branchId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      levelType = userIdentity.levelType,
      token = new Date().getTime();
  branchId = branchId || userIdentity.branchId;
  var url = '/branch/' + branchId + '/order/' + orderId + '?vip=' + levelType + '&r=' + token;
  var $httpSaas = createHttp();
  $httpSaas.interceptors.response.use(function (res) {
    if (res.preorder === __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].state.appConst.PRE_ORDER_Y && res.status === __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].state.appConst.ORDER_STATUS_PRE_ORDER) {
      // 未下单的预点餐
      // 就餐人数
      __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].commit('setPersonNum', res.persons);
      // 整单备注
      __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].commit('setOrderNote', res.note);
      // 预点餐信息
      __WEBPACK_IMPORTED_MODULE_9_src_config_store_config__["a" /* default */].commit('setPreOrderDetail', res);
    }
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(res);
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpSaas.get(url);
}

/**
 * GET /v1/org-id/{orgId}/order-user/{orderUserId}/order/{beginDay}/{endDay}
 * @param page 第几页
 * @return {Promise}
 */
function getOrderList() {
  var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

  var beginDay = 90 * (page - 1);
  var endDay = 90 * page;
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var url = '/org-id/' + userIdentity.orgId + '/order-user/' + userIdentity.userId + '/order/' + beginDay + '/' + endDay;
  var $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * 订单支付
 * 如果是微信和支付宝支付，服务器生成统一下单结果后告知客户端，客户端调起JSAPI，支付成功后跳转支付结果页面并通知saas支付结果
 * 如果是好会员支付，服务器直接调起好会员接口处理卡券、积分、储值卡消费
 * @author ytl
 * @param params
 * @return {Promise}
 */
function orderPay(params) {
  var orderId = params.orderId,
      payType = params.payType,
      discountList = params.discountList,
      topay = params.topay,
      payUser = params.payUser;

  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      requestId = new Date().getTime() + '' + orderId;
  var url = '/payment';
  var $httpSaas = createHttp();
  return $httpSaas.post(url, {
    uid: userIdentity.uid,
    authId: userIdentity.authId,
    branchId: userIdentity.branchId,
    orderId: orderId,
    orgId: userIdentity.orgId,
    payType: payType,
    payUser: payUser,
    requestId: requestId,
    discountList: discountList,
    topay: topay,
    mobilePayUser: userIdentity.userId
  });
}

/**
 * 微信/支付宝JSAPI支付成功后通知saas支付结果
 * post payment-notify
 * @param {String} outTradeNo 支付宝/微信统一下单的外部交易号
 * @return {Promise}
 */
function orderPayNotify(outTradeNo) {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var url = '/payment-notify';
  var $http = createHttp();
  return $http.post(url, {
    branchId: userIdentity.branchId,
    orgId: userIdentity.orgId,
    outTradeNo: outTradeNo
  });
}
/**
 * 查询某用户在门店台位的结账信息(如果已结算，返回结算账单信息，否则返回未结算，需要前端去门店查询最新下单信息
 * GET /v1/{branchid}/{tableid}/{tableno}/{uid}/cash/status
 * @return {Promise}
 */
function getTableFinishedOrder() {
  var _getUserIdentity = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity.branchId,
      tableId = _getUserIdentity.tableId,
      tableNo = _getUserIdentity.tableNo,
      userId = _getUserIdentity.userId,
      url = '/' + branchId + '/' + tableId + '/' + tableNo + '/' + userId + '/cash/status',
      $http = createHttp();

  return $http.get(url);
}

/**
 * 必点菜用，查询是否下单
 * GET /v1/check/has-bill/{userid}/{branchid}/{tableno}
 * @return {Promise}
 */
function checkHasBill() {
  var _getUserIdentity2 = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity2.branchId,
      tableNo = _getUserIdentity2.tableNo,
      userId = _getUserIdentity2.userId,
      url = '/check/has-bill/' + userId + '/' + branchId + '/' + tableNo,
      $http = createHttp();

  return $http.get(url);
}

/**
 * 后支付结账
 * POST /v1/scan/code/payment
 * @param {Object} params 结账参数
 * @return {Promise}
 */
function afterPay(params) {
  var _getUserIdentity3 = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      orgId = _getUserIdentity3.orgId,
      authId = _getUserIdentity3.authId,
      branchId = _getUserIdentity3.branchId,
      uid = _getUserIdentity3.uid,
      levelType = _getUserIdentity3.levelType,
      _getUserIdentity3$mob = _getUserIdentity3.mobile,
      mobile = _getUserIdentity3$mob === undefined ? '' : _getUserIdentity3$mob,
      userId = _getUserIdentity3.userId,
      _getUserIdentity3$tab = _getUserIdentity3.tableId,
      tableId = _getUserIdentity3$tab === undefined ? 0 : _getUserIdentity3$tab,
      _getUserIdentity3$tab2 = _getUserIdentity3.tableNo,
      tableNo = _getUserIdentity3$tab2 === undefined ? '' : _getUserIdentity3$tab2,
      _getUserIdentity3$tab3 = _getUserIdentity3.tableName,
      tableName = _getUserIdentity3$tab3 === undefined ? '' : _getUserIdentity3$tab3,
      _getUserIdentity3$sho = _getUserIdentity3.showname,
      showname = _getUserIdentity3$sho === undefined ? '' : _getUserIdentity3$sho;

  var orderChannel = Object(__WEBPACK_IMPORTED_MODULE_5_components_api_utils__["k" /* getClientType */])();
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(params, {
    orgId: orgId,
    authId: authId,
    branchId: branchId,
    brandId: uid,
    orderChannel: orderChannel,
    customerLevel: levelType,
    mobile: mobile,
    tableId: tableId,
    tableName: tableName,
    tableno: tableNo,
    uname: showname,
    mobilePayUser: userId
  });
  var url = '/scan/code/payment';
  return createHttp().post(url, params);
}
/**
 * 查询用户待下单的预点餐
 * GET /v1/order/{branchid}/{uid}/summary
 * @return {Promise}
 */
function getUserPreOrderSummary() {
  var _getUserIdentity4 = Object(__WEBPACK_IMPORTED_MODULE_6_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity4.branchId,
      userId = _getUserIdentity4.userId;

  var url = '/order/' + branchId + '/' + userId + '/summary';
  return createHttp().get(url);
}

/***/ }),

/***/ "oAV5":
/***/ (function(module, exports) {

/**
 * 页面调用的一些方法
 **/

// 第一种修改conponents的title的方法 ：
var setWechatTitle = function setWechatTitle(title) {
    document.title = title;
    var mobile = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(mobile)) {
        var iframe = document.createElement('iframe');
        iframe.style.visibility = 'hidden';
        // 替换成站标favicon路径或者任意存在的较小的图片即可
        // iframe.setAttribute('src', '//m.baidu.com/favicon.ico');
        var iframeCallback = function iframeCallback() {
            setTimeout(function () {
                iframe.removeEventListener('load', iframeCallback);
                document.body.removeChild(iframe);
            }, 10);
        };
        iframe.addEventListener('load', iframeCallback);
        document.body.appendChild(iframe);
    }
};

// 第二种修改title的方法，其中包含iframe的设置：
var setTitleHack = function setTitleHack(t) {
    document.title = t;
    var iframe = document.createElement('iframe');
    iframe.style.visibility = 'hidden';
    iframe.style.width = '1px';
    iframe.style.height = '1px';
    // iframe.src = '//m.baidu.com/favicon.ico';
    iframe.onload = function () {
        setTimeout(function () {
            iframe.remove();
        }, 10);
    };
    document.body.appendChild(iframe);
};

module.exports = {
    setWechatTitle: setWechatTitle,
    setTitleHack: setTitleHack
};

/***/ }),

/***/ "oYRo":
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__("FZ+f")(false);
// imports


// module
exports.push([module.i, "\n.takeCardsWrapper {\n  width: 90vw;\n  border-radius: 0.2rem;\n}\n.takeCardsWrapper .title {\n  font-size: 0.43rem;\n  padding: 0.2rem;\n  color: #f13b3a;\n  background: #eee;\n  border-top-left-radius: 0.2rem;\n  border-top-right-radius: 0.2rem;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.takeCardsWrapper .title span {\n  font-weight: bold;\n  margin-left: 0.15rem;\n}\n.takeCardsWrapper .content {\n  min-height: 30vh;\n  max-height: 70vh;\n  font-size: 0.37rem;\n  padding: 0 0.2rem 0.3rem 0.2rem;\n  overflow-y: auto;\n}\n.takeCardsWrapper .footer {\n  border-bottom-left-radius: 0.2rem;\n  border-bottom-right-radius: 0.2rem;\n  padding: 10px;\n}\n.takeCardsWrapper .footer button {\n  border-radius: 4px;\n}\n", ""]);

// exports


/***/ }),

/***/ "pT0i":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// vuex模块：常量管理
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    // 菜品默认选多份
    FOOD_MULTIPLE_YES: 'YES',
    FOOD_MULTIPLE_NO: 'NO',
    // 菜品必填
    FOOD_REQUIRED_YES: 'YES',
    FOOD_REQUIRED_NO: 'NO',
    // 必选菜数量限制 (ATLSTONE=至少1分，PERPEOPLE=按人数)
    FOOD_REQUIRED_ATLSTONE: 'ATLSTONE',
    FOOD_REQUIRED_PERPEOPLE: 'PERPEOPLE',
    // 菜品要求必选
    FOOD_SETTING_MUST_YES: 'YES',
    // 菜品可用状态 USING：在用，UNUSED：未用
    FOOD_STATUS_USING: 'USING',
    FOOD_STATUS_UNUSED: 'UNUSED',
    // 菜品数量是否可为小数
    FOOD_CAN_FLOAT_YES: 'YES',
    // 菜品套餐 SET_MEAL
    FOOD_TYPE_SET_MEAL: 'SET_MEAL',
    // 套餐分组菜是否默认
    SET_MEAL_FOOD_DEFAULT_Y: 'Y',
    // 套餐分组菜是否必选
    SET_MEAL_FOOD_REQUIRED_Y: 'Y',
    SET_MEAL_FOOD_REQUIRED_N: 'N',
    // 套餐分组菜是否可重复选择
    SET_MEAL_FOOD_REPEAT_Y: 'Y',
    SET_MEAL_FOOD_REPEAT_N: 'N',
    // goods列表是否显示会员价 displayVipPrice (YES, NO)
    VIP_PRICE_DISPLAY_YES: 'YES',
    VIP_PRICE_DISPLAY_NO: 'NO',
    // 是否强制收集就餐人数
    PEOPLE_NUM_YES: 'YES',
    PEOPLE_NUM_NO: 'NO',
    // 是否预点餐订单
    PRE_ORDER_Y: 'Y',
    PRE_ORDER_N: 'N',
    // 订单状态（部分）
    ORDER_STATUS_PRE_ORDER: 'PRE_ORDER',
    // 储值规则类型：手机储值
    PAY_RULE_TYPE_ONLINE: 'ONLINE',
    // 是否只在使用储值余额支付时享有优惠
    CHEAP_PREPAID_ONLY: 'YES',
    // 是否享受会员优惠
    CHEAP_RATE_RIGHT: 'YES'

  }
});

/***/ }),

/***/ "pkiq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AliScanPay */
/* unused harmony export AlipayWithoutOrder */
/* unused harmony export AliScanOrderDetail */
/* unused harmony export AliScanError */
/* unused harmony export orderCenter */
/* unused harmony export allOrders */
/* unused harmony export orderDetail */
/* unused harmony export goods */
/* unused harmony export order */
/* unused harmony export pay */
/* unused harmony export payResult */
/* unused harmony export stores */
/* unused harmony export navigation */
/* unused harmony export regist */
/* unused harmony export HomeWechatScan */
/* unused harmony export SuitDetail */
/* unused harmony export Feedback */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__ = __webpack_require__("rlVW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils__ = __webpack_require__("oAV5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_utils___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__utils_utils__);
/**
 * Created by Administrator on 2017/7/18 0018.
 */





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

// 支付宝-码上付
var AliScanPay = function AliScanPay() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Dg5j"));
};
var AlipayWithoutOrder = function AlipayWithoutOrder() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "uC5z"));
};
var AliScanOrderDetail = function AliScanOrderDetail() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "eFsm"));
};
var AliScanError = function AliScanError() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "ToN/"));
};

// 订单中心
var orderCenter = function orderCenter() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "muTS"));
};
var allOrders = function allOrders() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "Mn4o"));
};
var orderDetail = function orderDetail() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "kzy0"));
};

// 点餐
var goods = function goods() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "dfnC"));
};
var order = function order() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "AkY+"));
};
var pay = function pay() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "U562"));
};
var payResult = function payResult() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "LI0+"));
};

// 位置相关
var stores = function stores() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "LARZ"));
};
var navigation = function navigation() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "Lq+o"));
};
var regist = function regist() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "1osu"));
};

// 其他
var distribution = function distribution() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "Hzvr"));
};
var errorPage = function errorPage() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "GwfU"));
};
var errorPage2 = function errorPage2() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "24mF"));
};
var aliScan = function aliScan() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "tUV8"));
};

// 微信扫码点餐首页
var HomeWechatScan = function HomeWechatScan() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "d0uj"));
};
// 套餐详情
var SuitDetail = function SuitDetail() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Ilq8"));
};
// 投诉建议
var Feedback = function Feedback() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "mTLr"));
};

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  /* scrollBehavior: () => ({ // 滚动条滚动的行为，不加这个默认就会记忆原来滚动条的位置
   y: 0
   }), */
  routes: [{
    path: '/goods',
    name: 'goods',
    component: goods,
    meta: {
      title: '点餐'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["j" /* WHITE_BODY */];
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/regist',
    component: regist
  }, {
    path: '/distribution', // 选择就餐时间/就餐人数
    name: 'distribution',
    component: distribution,
    meta: {
      title: ''
    }
  }, {
    path: '/pay/:orderId',
    name: 'pay',
    component: pay,
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    },

    meta: {
      keep: true,
      title: '订单支付',
      allowBack: false
    }
  }, {
    path: '/payResult/:orderId/:branchId',
    name: 'payResult',
    component: payResult,
    meta: {
      title: '支付完成'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/order',
    name: 'order',
    component: order,
    meta: {
      keep: true,
      title: '确认订单'
    }
  }, {
    path: '/orderCenter',
    component: orderCenter,
    children: [{
      path: '/',
      redirect: 'allOrders'
    }, {
      path: 'allOrders',
      name: 'allOrders',
      component: allOrders,
      meta: {
        keep: true,
        title: '全部订单'
      },
      beforeEnter: function beforeEnter(to, from, next) {
        Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
        window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
        next();
      },
      beforeLeave: function beforeLeave(to, from, next) {
        window.document.body.style.backgroundColor = '';
        next();
      }
    }],
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/orderDetail/:orderId/:branchId',
    name: 'orderDetail',
    component: orderDetail,
    meta: {
      keep: true,
      title: '订单信息'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/stores',
    name: 'stores',
    component: stores,
    meta: {
      title: '门店列表'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      next();
    }
  }, {
    path: '/navigation',
    name: 'navigation',
    component: navigation,
    meta: {
      title: '导航',
      keep: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      next();
    }
  }, {
    path: '/error',
    name: 'error',
    component: errorPage,
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/error2',
    name: 'error2',
    component: errorPage2,
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScan', // 支付宝扫一扫
    name: 'aliScan',
    component: aliScan,
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/feedback',
    name: 'feedback',
    component: Feedback,
    meta: {
      title: '意见反馈'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      Object(__WEBPACK_IMPORTED_MODULE_3__utils_utils__["setTitleHack"])(to.meta.title);
      window.document.body.style.backgroundColor = '#f2f5fa';
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScanPay', // 支付宝码上付
    name: 'aliScanPay',
    component: AliScanPay,
    meta: {
      title: '买单',
      keep: true
    },
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/alipayWithOutOrder', // 支付宝码上付兜底支付页面
    name: 'alipayWithOutOrder',
    component: AlipayWithoutOrder,
    meta: {
      title: '买单'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliError', // 支付宝码上付兜底错误页面
    name: 'aliError',
    component: AliScanError,
    meta: {
      title: '买单'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/aliScanOrderDetail', // 支付宝card位订单详情
    name: 'aliScanOrderDetail',
    component: AliScanOrderDetail,
    meta: {
      title: '订单信息'
    },
    beforeEnter: function beforeEnter(to, from, next) {
      window.document.body.style.backgroundColor = __WEBPACK_IMPORTED_MODULE_2_components_api_index_web__["f" /* GRAY_BODY */];
      next();
    },
    beforeLeave: function beforeLeave(to, from, next) {
      window.document.body.style.backgroundColor = '';
      next();
    }
  }, {
    path: '/home', // 微信扫码点餐首页
    name: 'home',
    component: HomeWechatScan,
    meta: {
      title: '欢迎光临',
      keep: true
    }
  }, {
    path: '/suitDetail', // 套餐详情页
    name: 'suitDetail',
    component: SuitDetail,
    meta: {
      title: '套餐详情',
      keep: true
    }
  }],
  linkActiveClass: 'active'
}));

/***/ }),

/***/ "qkUO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BUSINESS_TYPE_TS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BUSINESS_TYPE_MC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BUSINESS_TYPE_ZT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BUSINESS_TYPE_WS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BUSINESS_TYPE_JC; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NEED_PACKAGE_YES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return NEED_PACKAGE_NO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return DICT_GROUP_BUSINESS_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BUSINESS_TYPE_STATUS_OPEN; });
/* unused harmony export BUSINESS_TYPE_STATUS_NO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TS_PAY_TYPE_BEFORE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return TS_PAY_TYPE_AFTER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return TS_PAY_TYPE_NOPAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TS_PAY_TYPE_BOTH; });
/* unused harmony export createHttp */
/* unused harmony export createHttpTest */
/* harmony export (immutable) */ __webpack_exports__["q"] = getDictItems;
/* harmony export (immutable) */ __webpack_exports__["p"] = getBusinessSetting;
/* harmony export (immutable) */ __webpack_exports__["t"] = getGoodsList;
/* unused harmony export getJikouList */
/* harmony export (immutable) */ __webpack_exports__["o"] = getBranchTimeList;
/* harmony export (immutable) */ __webpack_exports__["n"] = getBranchBusinessInfo;
/* harmony export (immutable) */ __webpack_exports__["u"] = getSettingOption;
/* unused harmony export getRecommendFoods */
/* harmony export (immutable) */ __webpack_exports__["v"] = getTableInfo;
/* unused harmony export getFoodsActivityPrice */
/* harmony export (immutable) */ __webpack_exports__["r"] = getFoodDetail;
/* harmony export (immutable) */ __webpack_exports__["s"] = getFoodsVipPrice;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_api_utils__ = __webpack_require__("X623");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__ = __webpack_require__("UZDt");

/**
 * saas接口相关
 * @author ytl
 */






// businessType 堂食自助(（扫码点餐）):TS，秒吃(预约堂食)：MC，自提（预约自提）：ZT，外送（预约外送）：WS，
var BUSINESS_TYPE_TS = 'TS';
var BUSINESS_TYPE_MC = 'MC';
var BUSINESS_TYPE_ZT = 'ZT';
var BUSINESS_TYPE_WS = 'WS';
var BUSINESS_TYPE_JC = 'JC';

// 是否需要打包
var NEED_PACKAGE_YES = 'YES';
var NEED_PACKAGE_NO = 'NO';

// 字典 dictGroup
var DICT_GROUP_BUSINESS_TYPE = 'BUSINESS_TYPE';

// 业务开通状态 OPEN/NO
var BUSINESS_TYPE_STATUS_OPEN = 'OPEN';
var BUSINESS_TYPE_STATUS_NO = 'NO';

// 扫码点餐之后类型 先支付/后支付/只点餐不结账/点餐支付+扫码结账
var TS_PAY_TYPE_BEFORE = 'BEFORE';
var TS_PAY_TYPE_AFTER = 'AFTER';
var TS_PAY_TYPE_NOPAY = 'NOPAY';
var TS_PAY_TYPE_BOTH = 'BOTH';

/**
 * 创建axios实例
 * @return {axios}
 */
function createHttp() {
  var $httpSaas = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_2_src_config_params_local__["e" /* INTERACE_SAAS_BASE_URL */],
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    timeout: 30000
  });

  // 添加一个响应拦截器
  $httpSaas.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["w" /* logging */])({ request: res.config, responseData: res.data });
      var errMsg = { message: res.data.msg ? res.data.msg : '' };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, function (err) {
    var responseData = err.response ? err.response.data : null;
    Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["w" /* logging */])({
      request: err.config,
      responseData: responseData,
      err: responseData ? null : err
    });
    var errorInfo = err.response ? err.response.data : err;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errorInfo);
  });
  return $httpSaas;
}

/**
 * 创建axios实例--测试
 * @return {axios}
 */
function createHttpTest() {
  var $httpSaas = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create();
  // 添加一个响应拦截器
  $httpSaas.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      var errMsg = { response: { data: { message: res.data.msg ? res.data.msg : '' } } };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return res.data.body ? res.data.body : res.data;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpSaas;
}

/**
 * 查询字段数据接口
 * @param dictGroup 字典组编码
 * @param dictCode 字典详情编码 ''表示查询所有
 * @return {Promise}
 */
function getDictItems(dictGroup) {
  var dictCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var dictItems = Object(__WEBPACK_IMPORTED_MODULE_3_components_api_utils__["l" /* getLocalStorageItem */])('dictItems') ? Object(__WEBPACK_IMPORTED_MODULE_3_components_api_utils__["l" /* getLocalStorageItem */])('dictItems') : {};
  if (!dictItems || !dictItems[dictGroup] || dictCode !== '' && !dictItems[dictGroup][dictCode]) {
    var url = '/dict-group/' + dictGroup + '/dict-item';
    var $httpSaas = createHttp();
    $httpSaas.interceptors.response.use(function (res) {
      dictItems[dictGroup] = {};
      res.forEach(function (row) {
        var itemDictCode = row.reDictItem.dictCode;
        dictItems[dictGroup][itemDictCode] = row.reDictItem;
      });
      Object(__WEBPACK_IMPORTED_MODULE_3_components_api_utils__["s" /* setLocalStorageItem */])('dictItems', dictItems, 86400);
      return dictCode ? row.reDictItem : dictItems[dictGroup];
    });
    return $httpSaas.get(url);
  }

  if (dictCode === '') {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(dictItems[dictGroup]);
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(dictItems[dictGroup][dictCode]);
}
/**
 * GET /v1/branch/{branchId}/mc-setting
 * GET /v1/branch/{branchId}/ts-setting
 * GET /v1/branch/{branchId}/ws-setting
 * GET /v1/branch/{branchId}/zt-setting
 * 获取业务设置信息
 * @return {Promise}
 */
function getBusinessSetting() {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      businessType = userIdentity.businessType.toLocaleLowerCase(),
      url = '/branch/' + userIdentity.branchId + '/' + businessType + '-setting' + '?r=' + new Date().getTime(),
      $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * /food-catalog/branch-id/{branchId}/customer-level/{customerLevel}/business-type/{businessType}/business-hours/{businessHours}
 * 获取菜例列表
 * @param businessHours 扫码点餐无需传递；
 * @param businessType
 * @return {Promise}
 */
function getGoodsList(businessType) {
  var businessHours = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var menuType = userIdentity.menuType;

  var url = void 0;
  if (menuType) {
    url = '/food-catalog/branch-id/' + userIdentity.branchId + '/customer-level/' + userIdentity.levelType + '/business-type/' + businessType + '/business-hours/' + businessHours + '/menu?menuType=' + menuType;
  } else {
    url = '/food-catalog/branch-id/' + userIdentity.branchId + '/customer-level/' + userIdentity.levelType + '/business-type/' + businessType + '/business-hours/' + businessHours + '/new';
  }
  var $httpSaas = createHttp();
  $httpSaas.interceptors.response.use(function (res) {
    var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_3_components_api_utils__["m" /* getSessionStorageItem */])('userIdentity');
    var isJC = userIdentity.isJC;

    if (res.length > 0 && isJC !== 'NO') {
      var results = void 0;
      results = res.filter(function (item) {
        return item.className !== '推荐菜';
      });
      return results;
    }
    return res;
  }, function (err) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $httpSaas.get(url);
}

/**
 * GET /setting/branch/{branchId}/set-template/{settingTypes}/page/{page}/page-size/{pageSize}
 * 获取忌口列表
 * @return {Promise}
 */
function getJikouList() {
  var branchId = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])('branchId');
  var url = '/setting/branch/' + branchId + '/set-template/JIKOU/page/1/page-size/100';
  var $httpSaas = createHttp();
  return $httpSaas.get(url);
}

/**
 * 订餐时间列表
 * GET /v1/branch/{id}/business-type/{type}/time-list
 * @param {Number} branchId
 * @return {Promise}
 */
function getBranchTimeList(branchId) {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var url = '/branch/' + branchId + '/business-type/' + userIdentity.businessType + '/time-list';
  var $http = createHttp();
  return $http.get(url);
}

/**
 * 查询门店设置信息
 * GET /v1/branch/{branchId}/business-info
 * @param {Number} branchId
 * @return {Promise}
 */
function getBranchBusinessInfo() {
  var branchId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  !branchId && (branchId = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])().branchId);
  var url = '/branch/' + branchId + '/business-info';
  var $http = createHttp();
  return $http.get(url);
}
/**
* 忌口消息
* GET /v1/setting/branch/{branchId}/setting-option
* @param {Number} branchId
* @return {Promise}
  */
function getSettingOption(branchId) {
  var userIdentity = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])();
  var url = '/setting/branch/' + userIdentity.branchId + '/setting-option';
  var $http = createHttp();
  return $http.get(url);
}
/**
 * 查询推荐菜列表
 * GET /{branchid}/recommended/food/list
 * @return {Promise}
 */
function getRecommendFoods() {
  var _getUserIdentity = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity.branchId,
      levelType = _getUserIdentity.levelType,
      url = '/' + branchId + '/' + levelType + '/recommended/food/list',
      $http = createHttp();

  return $http.get(url);
}

/**
 * 查询桌台基本信息
 * GET /v1/branch/{branchid}/{tableno}/{tableid}/table/info
 */
function getTableInfo() {
  var _getUserIdentity2 = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity2.branchId,
      _getUserIdentity2$tab = _getUserIdentity2.tableId,
      tableId = _getUserIdentity2$tab === undefined ? 0 : _getUserIdentity2$tab,
      _getUserIdentity2$tab2 = _getUserIdentity2.tableNo,
      tableNo = _getUserIdentity2$tab2 === undefined ? 0 : _getUserIdentity2$tab2;

  var url = '/branch/' + branchId + '/' + (tableNo || 0) + '/' + tableId + '/table/info',
      $http = createHttp();
  return $http.get(url);
}

// POST /v1/branch/food/promotion/price
/**
 * 门店菜获取好客云活动价格
 * 该接口只返回有活动价的菜
 * @param {Array} foods
 */
function getFoodsActivityPrice(foodList) {
  var _getUserIdentity3 = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity3.branchId,
      userLevel = _getUserIdentity3.levelType;

  var url = '/branch/food/promotion/price',
      params = {
    branchId: branchId,
    channel: '',
    foodList: foodList,
    userLevel: userLevel,
    bizType: BUSINESS_TYPE_TS
  },
      $http = createHttp();
  return $http.post(url, params);
}

/**
 * 查询菜品详情
 * GET /v1/branch/{branchId}/food/{id}
 * @param foodId
 */
function getFoodDetail(foodId) {
  var _getUserIdentity4 = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity4.branchId,
      url = '/branch/' + branchId + '/food/' + foodId;

  return createHttp().get(url);
  // return createHttpTest().get('/static/test/foodOptional.json');
}
/**
 * 批量查询菜品会员价
 * /v1/branch/food/vip/promotion/price
 * @param foodList
 * @return {Promise}
 */
function getFoodsVipPrice(foodList) {
  var _getUserIdentity5 = Object(__WEBPACK_IMPORTED_MODULE_4_components_api_interface_hhy__["p" /* getUserIdentity */])(),
      branchId = _getUserIdentity5.branchId,
      businessType = _getUserIdentity5.businessType,
      url = '/branch/food/vip/promotion/price';

  return createHttp().post(url, {
    branchId: branchId,
    foodList: foodList,
    bizType: businessType
  });
}

/***/ }),

/***/ "rlVW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GRAY_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return WHITE_BODY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CAN_MULTI; });
/* unused harmony export CAN_NOT_MULTI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CAN_MUST; });
/* unused harmony export CAN_NOT_MUST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CAN_CHECK; });
/* unused harmony export CAN_NOT_CHECK */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFALUT_ADDRESS; });
/* unused harmony export NOT_DEFAULT_ADDRESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CAN_PACKAGE; });
/* unused harmony export CAN_NOT_PACKAGE */
/* unused harmony export WORDS_LIMIT */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TIME_COUNT; });
/* unused harmony export RESPONSE_CODE_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESPONSE_CODE_FAIL; });
/* unused harmony export UPDATE_USER_INFO_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return TOTAL_PRICE_IS_ZERO; });
var GRAY_BODY = '#efefef';
var WHITE_BODY = '#FFF';

// 菜品要求是否多选
var CAN_MULTI = 'YES';
var CAN_NOT_MULTI = 'NO';

// 菜品要求是否必选
var CAN_MUST = 'YES';
var CAN_NOT_MUST = 'NO';

// 首次下单是否需要验证手机号
var CAN_CHECK = 'YES';
var CAN_NOT_CHECK = 'NO';

// 是否默认地址
var DEFALUT_ADDRESS = 'YES';
var NOT_DEFAULT_ADDRESS = 'NO';
// 是否允许打包
var CAN_PACKAGE = 'YES';
var CAN_NOT_PACKAGE = 'NO';
// 字数限制
var WORDS_LIMIT = 50;
// 验证码倒计时
var TIME_COUNT = 60;

// 接口自定义code状态
var RESPONSE_CODE_SUCCESS = 'SUCCESS';
var RESPONSE_CODE_FAIL = 'FAIL';

var UPDATE_USER_INFO_SUCCESS = 'SUCCESS';
// 总金额为零
var TOTAL_PRICE_IS_ZERO = 0;

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-in": "yJfC",
	"./en-in.js": "yJfC",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./en-sg": "NYST",
	"./en-sg.js": "NYST",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fil": "rMbQ",
	"./fil.js": "rMbQ",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-deva": "VGQH",
	"./gom-deva.js": "VGQH",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./oc-lnc": "KOFO",
	"./oc-lnc.js": "KOFO",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tk": "+WRH",
	"./tk.js": "+WRH",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-mo": "+WA1",
	"./zh-mo.js": "+WA1",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wMDt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createHttp */
/* harmony export (immutable) */ __webpack_exports__["a"] = weChatJsSdkSign;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_config_params_local__ = __webpack_require__("MTb8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_src_components_api_interface_hhy__ = __webpack_require__("UZDt");






/**
 * 创建axios实例
 * @return {axios}
 */
function createHttp() {
  var $http = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_3_src_config_params_local__["g" /* INTERFACE_GATEWAY_URL */],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
      'Cache-Control': 'no-cache'
    },
    transformRequest: [function (data) {
      return __WEBPACK_IMPORTED_MODULE_1_qs___default.a.stringify(data);
    }],
    timeout: 30000
  });

  // 添加一个响应拦截器
  $http.interceptors.response.use(function (res) {
    if (res.data.code && res.data.code === -1) {
      Object(__WEBPACK_IMPORTED_MODULE_4_src_components_api_interface_hhy__["w" /* logging */])({ request: res.config, responseData: res.data });
      var errMsg = { response: { data: { message: res.data.msg ? res.data.msg : '' } } };
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(errMsg);
    }
    return 'body' in res.data ? res.data.body : res.data;
  }, function (err) {
    var responseData = err.response ? err.response.data : null;
    Object(__WEBPACK_IMPORTED_MODULE_4_src_components_api_interface_hhy__["w" /* logging */])({
      request: err.config,
      responseData: responseData,
      err: responseData ? null : err
    });
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
  });
  return $http;
}

/**
 * 获取JSSDK签名
 * POST /wechat/msg/jssdk/sign
 */
function weChatJsSdkSign(params) {
  var url = '/wechat/msg/jssdk/sign';
  var clientUrl = params.clientUrl,
      stamp = params.stamp,
      nonce = params.nonce;

  return createHttp().post(url, {
    url: clientUrl,
    stamp: stamp,
    nonce: nonce,
    appid: Object(__WEBPACK_IMPORTED_MODULE_4_src_components_api_interface_hhy__["p" /* getUserIdentity */])('appId')
  });
}

/***/ }),

/***/ "wp25":
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__("91KU");
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__("rjj0")("1b6d18ea", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8308e664\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TakeCardItem.vue", function() {
     var newContent = require("!!../../../node_modules/css-loader/index.js?{\"minimize\":false,\"sourceMap\":false}!../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-8308e664\",\"scoped\":false,\"hasInlineConfig\":false}!../../../node_modules/stylus-loader/index.js?{\"sourceMap\":false}!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./TakeCardItem.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("NYxO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_common_TakeCardsModal__ = __webpack_require__("hExl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_src_components_common_Welcome__ = __webpack_require__("zu8I");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  metaInfo: function metaInfo() {
    return {
      title: this.$route.path === '/' ? '' : this.$route.meta.title ? this.$route.meta.title : '点餐'
    };
  },
  data: function data() {
    return {
      title: '',
      inputTimer: 0 // input blur定时器
    };
  },

  components: {
    takeCardsModal: __WEBPACK_IMPORTED_MODULE_2_src_components_common_TakeCardsModal__["a" /* default */],
    welcome: __WEBPACK_IMPORTED_MODULE_3_src_components_common_Welcome__["a" /* default */]
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["e" /* mapState */])(['popStateListener', 'takeCardsModalVisible', 'welcomeImgVisible'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["d" /* mapMutations */])(['deletePopStateListener', 'addPopStateListener']), {
    /**
     * 解决：IOS键盘收起后，弹出框内的点击事件错位
     * 输入框失去焦点后滚动到原始位置
     * @param e
     */
    inputBlur: function inputBlur(e) {
      // 首先，判断触发事件的目标元素是否是input输入框，我们只关注输入框的行为。
      if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
        // 输入框失去焦点，要把IOS键盘推出页面的滚动部分还原。即将页面滚动到视窗顶部对齐
        this.inputTimer = setTimeout(function () {
          window.scrollTo(0, 0);
        }, 100);
      }
    },

    /**
     * 防止input之间切换时触发blur事件的滚动，引起抖动
     * @param e
     */
    inputFocus: function inputFocus(e) {
      // 如果focus，则移除上一个输入框的timer
      if (e && e.target && e.target.tagName && e.target.tagName.toLowerCase() === 'input') {
        clearTimeout(this.inputTimer);
      }
    }
  }),
  created: function created() {},
  mounted: function mounted() {
    // 全屏子组件监听手机返回按键(例如从菜品详情返回到菜例列表页，而不是返回到上级路由)
    var self = this;
    window.addEventListener('popstate', function (e) {
      if (self.popStateListener.length > 0) {
        self.deletePopStateListener();
      }
      return false;
    }, false);
    // 弹出键盘 窗口缩放
    var windowHeight = window.innerHeight;
    window.addEventListener('resize', function () {
      if (window.innerHeight === windowHeight) {
        // 收起键盘
        document.activeElement.blur();
        //          setTimeout(() => {
        //            let scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        //            window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        //          }, 100);
      }
    });
  }
});

/***/ }),

/***/ "yeJ9":
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),

/***/ "zu8I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("d7ik");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcedba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("K390");
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__("cMrd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fdcedba4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/common/Welcome.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fdcedba4", Component.options)
  } else {
    hotAPI.reload("data-v-fdcedba4", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.4a4bd8d736eb15818d49.js